/* NutriFitt × Lee Priest — Sanctum: a live nave behind the Resurrection chapters. */
(() => {
  'use strict';
  if (window.NFSanctum) return;
  const PAL = {
    blood: { fog: [0.30, 0.018, 0.028], light: [1.0, 0.22, 0.14], stone: [0.085, 0.06, 0.062], accent: [0.9, 0.1, 0.1], ember: [1.0, 0.32, 0.12], dens: 0.055, rays: 0.8, holy: 0, moon: 0, acc: 0, emb: 1, fire: 0.2, pool: 1, liq: [1.0, 0.26, 0.24] },
    bone: { fog: [0.16, 0.03, 0.035], light: [1.0, 0.8, 0.7], stone: [0.1, 0.085, 0.08], accent: [0.9, 0.1, 0.12], ember: [1.0, 0.9, 0.8], dens: 0.06, rays: 0.55, holy: 0, moon: 0, acc: 0.5, emb: 0.6, fire: 0, pool: 0.6, liq: [1.0, 0.32, 0.3] },
    fire: { fog: [0.38, 0.07, 0.015], light: [1.0, 0.5, 0.12], stone: [0.09, 0.055, 0.04], accent: [1.0, 0.3, 0.05], ember: [1.0, 0.55, 0.15], dens: 0.06, rays: 1.1, holy: 0, moon: 0, acc: 0.4, emb: 1.6, fire: 1, pool: 0.55, liq: [1.0, 0.46, 0.26] },
    steel: { fog: [0.1, 0.1, 0.12], light: [0.85, 0.88, 1.0], stone: [0.08, 0.08, 0.09], accent: [1.0, 0.08, 0.1], ember: [0.9, 0.92, 1.0], dens: 0.06, rays: 0.7, holy: 0, moon: 0, acc: 0.7, emb: 0.5, fire: 0, pool: 0.4, liq: [0.95, 0.32, 0.32] },
    holy: { fog: [0.12, 0.24, 0.36], light: [0.75, 0.93, 1.0], stone: [0.08, 0.1, 0.12], accent: [0.4, 0.8, 1.0], ember: [0.85, 0.97, 1.0], dens: 0.05, rays: 1.2, holy: 1, moon: 0, acc: 0.3, emb: 0.7, fire: 0, pool: 0.85, liq: [0.55, 0.85, 1.0] },
    moon: { fog: [0.3, 0.012, 0.02], light: [1.0, 0.12, 0.06], stone: [0.07, 0.045, 0.048], accent: [1.0, 0.1, 0.05], ember: [1.0, 0.25, 0.1], dens: 0.05, rays: 0.9, holy: 0, moon: 1, acc: 0.2, emb: 1.1, fire: 0.3, pool: 1, liq: [1.0, 0.2, 0.18] },
    ice: { fog: [0.08, 0.16, 0.26], light: [0.7, 0.9, 1.0], stone: [0.07, 0.085, 0.1], accent: [0.35, 0.75, 1.0], ember: [0.85, 0.95, 1.0], dens: 0.055, rays: 1.0, holy: 0.45, moon: 0, acc: 0.6, emb: 0.8, fire: 0, pool: 0.7, liq: [0.55, 0.82, 1.0] },
    ash: { fog: [0.13, 0.1, 0.1], light: [0.95, 0.85, 0.8], stone: [0.085, 0.075, 0.075], accent: [1.0, 0.12, 0.14], ember: [0.9, 0.85, 0.8], dens: 0.06, rays: 0.6, holy: 0, moon: 0, acc: 0.8, emb: 0.9, fire: 0.1, pool: 0.5, liq: [1.0, 0.3, 0.28] }
  };
  const V3 = ['fog', 'light', 'stone', 'accent', 'ember', 'liq'];
  const V1 = ['dens', 'rays', 'holy', 'moon', 'acc', 'emb', 'fire', 'pool'];
  const UN = { fog: 'uFog', light: 'uLight', stone: 'uStone', accent: 'uAccent', ember: 'uEmber', dens: 'uDens', rays: 'uRays', holy: 'uHoly', moon: 'uMoon', acc: 'uAcc', emb: 'uEmb', fire: 'uFire', liq: 'uLiq', pool: 'uPool' };
  const clone = p => JSON.parse(JSON.stringify(p));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const mix = (a, b, t) => a + (b - a) * t;
  const smooth = (a, b, v) => { const t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
  /* write only when a value actually changes: no style invalidation for nothing */
  const LAST = new WeakMap();
  const setv = (el, k, v) => { let m = LAST.get(el); if (!m) LAST.set(el, m = {}); if (m[k] === v) return; m[k] = v; if (k[0] === '-') el.style.setProperty(k, v); else el.style[k] = v; };
  const sett = (el, v) => { let m = LAST.get(el); if (!m) LAST.set(el, m = {}); if (m.t === v) return; m.t = v; el.textContent = v; };
  /* ---------- Device tier: a weak phone gets the same hall, drawn lighter ----------
     lite = bigger world grain, 30fps, fewer embers, no extra GL pane, no live blurs. Decided from the device's hints,
     from its GPU, and later from the frames it actually delivers (World.step). ?sxlite=1 / ?sxlite=0 forces it for the visit. */
  const TIER = { lite: false, forced: false };
  const goLite = () => {
    if (TIER.lite) return;
    TIER.lite = true;
    document.documentElement.classList.add('sx-lite');
    WORLDS.forEach(w => w.toLite());
    try { dispatchEvent(new Event('sx:lite')); } catch (e) {}
  };
  const WORLDS = [];
  (() => {
    let f = null;
    try { const m = /[?&]sxlite=([01])/.exec(location.search); if (m) sessionStorage.setItem('sxlite', m[1]); f = sessionStorage.getItem('sxlite'); } catch (e) {}
    if (f) { TIER.forced = true; if (f === '1') goLite(); return; }
    const n = navigator, c = n.connection || {};
    const ios = /iP(hone|ad|od)/.test(n.userAgent || '') || (n.maxTouchPoints > 1 && /Mac/.test(n.platform || ''));
    const coarse = matchMedia('(pointer: coarse)').matches;
    /* deviceMemory rounds to a power of two: 4 means a 4GB or 6GB phone. iPhones never report it and their GPUs cope. */
    if (c.saveData || (!ios && ((n.deviceMemory && n.deviceMemory <= 4) || (coarse && n.hardwareConcurrency && n.hardwareConcurrency <= 4)))) goLite();
  })();
  const LOW_GPU = /SwiftShader|llvmpipe|Software|Basic Render|Mali-(4\d\d|T\d|G31|G5[12]|G57 MC[1-3]|G7[12])|Adreno \(TM\) ([1-5]\d\d|60\d|61[0-3])\b|PowerVR|SGX|Vivante|VideoCore|GC\d{3,4}/i;
  const gpuCheck = gl => {
    if (TIER.lite || TIER.forced) return;
    try { const e = gl.getExtension('WEBGL_debug_renderer_info'); const r = String(gl.getParameter(e ? e.UNMASKED_RENDERER_WEBGL : gl.RENDERER) || ''); if (LOW_GPU.test(r)) goLite(); } catch (e) {}
  };
  /* ---------- Horseshoe windows: an engraved double line, a keystone, impost marks and a sill. No fills, no stripes ---------- */
  const SVGNS = 'http://www.w3.org/2000/svg';
  const archFrame = (box, clip, o = {}) => {
    if (!box || !clip || box._arch) return;
    box._arch = 1; box.classList.add('sxa-box');
    const svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'sxa' + (o.cls ? ' ' + o.cls : '')); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    box.appendChild(svg);
    const f = n => n.toFixed(1);
    const draw = () => {
      const W = box.clientWidth, H = box.clientHeight;
      if (W < 20 || H < 20) return;
      const p = o.pad == null ? 6 : o.pad, g = o.gap || 4, j = o.jamb || 0.93, t = o.tick == null ? 4 : o.tick;
      const R = W / 2 - p, r = R - g, cx = W / 2, cy = p + R, w = r * j, d = Math.sqrt(r * r - w * w), yI = cy + d, bot = H - (o.bottom == null ? p : o.bottom);
      const wo = R * j, yO = cy + R * d / r;
      const inner = `M${f(cx - w)} ${f(bot)}L${f(cx - w)} ${f(yI)}A${f(r)} ${f(r)} 0 1 1 ${f(cx + w)} ${f(yI)}L${f(cx + w)} ${f(bot)}`;
      const outer = `M${f(cx - wo)} ${f(bot)}L${f(cx - wo)} ${f(yO)}A${f(R)} ${f(R)} 0 1 1 ${f(cx + wo)} ${f(yO)}L${f(cx + wo)} ${f(bot)}`;
      /* impost marks where the arch springs, a sill that closes the window */
      const ticks = t ? `M${f(cx - R)} ${f(cy)}H${f(cx - r)}M${f(cx + r)} ${f(cy)}H${f(cx + R)}` : '';
      const sill = o.sill === false ? '' : `M${f(cx - wo - t)} ${f(bot)}H${f(cx + wo + t)}`;
      /* the keystone is a dagger driven down through both lines into the window; the imposts end in thorns */
      const yT = cy - R - Math.max(3, g * 0.8), yB = cy - r + Math.max(4, g * 1.3), yG = yT + (yB - yT) * 0.3, kw = Math.max(1.7, g * 0.42), gw = kw * 2.4;
      const key = `M${f(cx)} ${f(yT)}L${f(cx + kw)} ${f(yG)}L${f(cx)} ${f(yB)}L${f(cx - kw)} ${f(yG)}Z`;
      const guard = `M${f(cx - gw)} ${f(yG)}H${f(cx + gw)}`;
      const ts = Math.max(1.6, t * 0.45);
      const thorns = t ? `M${f(cx - R)} ${f(cy - ts)}L${f(cx - R - t * 1.5)} ${f(cy)}L${f(cx - R)} ${f(cy + ts)}ZM${f(cx + R)} ${f(cy - ts)}L${f(cx + R + t * 1.5)} ${f(cy)}L${f(cx + R)} ${f(cy + ts)}Z` : '';
      const q = p * 0.45, c = Math.min(6, q + 2);
      const al = o.alfiz ? `<path class="sxa__alfiz" d="M${f(q + c)} ${f(q)}H${f(W - q - c)}L${f(W - q)} ${f(q + c)}V${f(H - q - c)}L${f(W - q - c)} ${f(H - q)}H${f(q + c)}L${f(q)} ${f(H - q - c)}V${f(q + c)}Z"/>` : '';
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
      svg.innerHTML = al + `<path class="sxa__shade" d="${inner}"/><path class="sxa__o" d="${outer}${ticks}${sill}"/><path class="sxa__i" d="${inner}"/>` + (thorns ? `<path class="sxa__thorn" d="${thorns}"/>` : '') + `<path class="sxa__guard" d="${guard}"/><path class="sxa__key" d="${key}"/>`;
      const br = box.getBoundingClientRect(), cr = clip.getBoundingClientRect(), sx = br.width ? W / br.width : 1;
      const dx = (br.left - cr.left) * sx, dy = (br.top - cr.top) * sx;
      clip.style.setProperty('clip-path', `path("M${f(cx - w + dx)} ${f(bot + dy)}L${f(cx - w + dx)} ${f(yI + dy)}A${f(r)} ${f(r)} 0 1 1 ${f(cx + w + dx)} ${f(yI + dy)}L${f(cx + w + dx)} ${f(bot + dy)}Z")`, 'important');
    };
    draw();
    if ('ResizeObserver' in window) new ResizeObserver(() => requestAnimationFrame(draw)).observe(box);
    else addEventListener('resize', draw, { passive: true });
  };
  const hex = h => { const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})/i.exec(String(h || '').trim()); return m ? [1, 2, 3].map(i => parseInt(m[i], 16) / 255) : [0.9, 0.1, 0.1]; };
  const FL = 1.55, PITCH = 0.16;
  /* flavours that name their own colour: a watermelon bleeds red, a rocket pop runs blue */
  const TONE = { 'sour watermelon': '#e3122c', 'prodigy pop': '#2b6bff' };
  const toneOf = t => TONE[String(t || '').trim().toLowerCase()] || '';
  /* ember budgets: a flavour tap bursts, the first scroll into a part leaves a trace, going back only relights the hall */
  const FX_QUIET = { hall: 0, air: 0, flare: 0.5, kick: 0 };
  const FX_LEE_FIRST = { hall: 0.34, air: 0.14, flare: 0.85, kick: 0.6 };
  const FX_PDP_TAP = { hall: 0.45, air: 0.42 };
  const FX_PDP_FIRST = { hall: 0.2, air: 0.05, flare: 0.75, kick: 0.4 };
  /* preview mode (?sxpreview=1, remembered for the browser tab; ?sxpreview=0 turns it off): sealed flavours can be tapped to see
     their colour change, embers and art. Nothing is selected, the cart keeps the flavour that is actually in stock. */
  const PREVIEW = (() => {
    let on = false;
    try { const q = new URLSearchParams(location.search).get('sxpreview'); if (q != null) sessionStorage.setItem('sxpreview', q === '0' ? '0' : '1'); on = sessionStorage.getItem('sxpreview') === '1'; }
    catch (e) { on = /[?&]sxpreview(=1)?(&|$)/.test(location.search); }
    return on;
  })();
  const previewChip = () => {
    if (!PREVIEW || document.querySelector('.sx-preview-chip')) return;
    document.documentElement.classList.add('sx-preview');
    const c = document.createElement('p'); c.className = 'sx-preview-chip'; c.setAttribute('aria-hidden', 'true');
    c.textContent = 'Preview mode \u00b7 sealed flavours can be tried, not bought';
    document.body.appendChild(c);
  };

  /* compile + link without asking for the result: with KHR_parallel_shader_compile the page keeps running while the driver works */
  const shaderStart = (gl, fs) => {
    const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; };
    const pr = gl.createProgram(), vs = sh(gl.VERTEX_SHADER, 'attribute vec2 p;varying vec2 v;void main(){v=p*.5+.5;gl_Position=vec4(p,0.,1.);}'), f = sh(gl.FRAGMENT_SHADER, fs);
    gl.attachShader(pr, vs); gl.attachShader(pr, f); gl.linkProgram(pr);
    return { pr, vs, f };
  };
  const shaderProgram = (gl, fs, job) => {
    const { pr, vs, f } = job || shaderStart(gl, fs);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) throw new Error(gl.getShaderInfoLog(f) || gl.getShaderInfoLog(vs) || gl.getProgramInfoLog(pr) || 'link');
    gl.useProgram(pr);
    const b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    return pr;
  };

  /* ---------- The hypostyle: a forest of blood-and-bone arches, drawn live at low resolution and dithered into two ramps ---------- */
  const WFS = [
    'precision highp float;',
    'uniform vec2 uRes;uniform float uTime,uZ,uVel,uFlash,uUp,uShaft,uHaze,uEclipse,uStripe,uFogD,uQ,uShift,uDoor;',
    'uniform vec2 uLook;uniform vec4 uRip[4];uniform vec3 uPort;uniform vec4 uWave;uniform sampler2D uRamp;',
    '#define SP 2.6',
    '#define CX 2.4',
    '#define FL 1.55',
    '#define PITCH .16',
    '#define FLO -1.',
    '#define YI .95',
    '#define YC1 1.366',
    '#define R1 1.12',
    '#define T1 .2',
    '#define YC2 2.35',
    '#define R2 1.02',
    '#define T2 .18',
    '#define CEIL 3.75',
    '#define CW .1',
    '#define CP .15',
    '#define DEP .34',
    'float h2(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float n2(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h2(i),h2(i+vec2(1,0)),f.x),mix(h2(i+vec2(0,1)),h2(i+vec2(1,1)),f.x),f.y);}',
    'float by2(vec2 a){a=floor(a);return fract(dot(a,vec2(.5,a.y*.75)));}',
    'float by4(vec2 a){return by2(.5*a)*.25+by2(a);}',
    'float by8(vec2 a){return by4(.5*a)*.25+by2(a);}',
    /* one arcade wall, in its own plane. id: 0 void, 1 column, 2 capital/plinth, 3 pillar, 4 lower voussoirs, 5 upper voussoirs, 6 wall, 7 ceiling */
    'vec4 arc(vec2 p){float ax=abs(p.x);float e=CX*.5-ax;',
    ' if(p.y>CEIL)return vec4(7.,0.,0.,0.);',
    ' if(p.y<YI){if(e<CW)return vec4(1.,e/CW,0.,0.);',
    '  if(p.y>YI-.15&&e<CW+.02+.07*(p.y-YI+.15)/.15)return vec4(2.,(p.y-YI+.15)/.15,0.,0.);',
    '  if(p.y<FLO+.12&&e<CW+.045)return vec4(2.,.25,0.,0.);return vec4(0.);}',
    ' if(p.y<YI+.1&&e<CW+.1)return vec4(2.,1.,0.,0.);',
    ' vec2 q1=p-vec2(0.,YC1);float d1=length(q1);',
    ' if(e<CP*.55&&p.y<YC2)return vec4(3.,e/(CP*.55),0.,0.);',
    ' if(d1<R1){if(e<CP&&p.y<YC2)return vec4(3.,e/CP,0.,0.);return vec4(0.);}',
    ' if(d1<R1+T1)return vec4(4.,(d1-R1)/T1,q1);',
    ' if(e<CP&&p.y<YC2)return vec4(3.,e/CP,0.,0.);',
    ' if(p.y<YC2)return vec4(0.);',
    ' vec2 q2=p-vec2(0.,YC2);float d2=length(q2);',
    ' if(d2<R2)return vec4(0.);',
    ' if(d2<R2+T2)return vec4(5.,(d2-R2)/T2,q2);',
    ' return vec4(6.,0.,0.,0.);}',
    /* light falls from high windows on the left: a point is lit if its path back to the roof meets a window */
    'vec3 LS=normalize(vec3(.78,-1.,.16));',
    'float win(vec3 p){float s=(CEIL+.6-p.y)/-LS.y;vec2 q=p.xz-LS.xz*s;vec2 c=vec2(mod(q.x+1.3,CX*2.)-1.3,mod(q.y+.4,SP*2.)-.4);',
    ' return smoothstep(0.,.06,c.x)*smoothstep(.5,.44,c.x)*smoothstep(0.,.08,c.y)*smoothstep(1.,.92,c.y);}',
    /* S = bone light, A = blood light. Uplights sit at the foot of the aisle columns */
    'float flick(vec2 id){float h=h2(id);return .82+.18*sin(uTime*(2.3+h*2.1)+h*40.)*sin(uTime*1.31+h*9.);}',
    'float upl(vec3 p,float k){float cx=floor(p.x/CX)*CX+CX*.5;float side=mix(.22,1.,smoothstep(3.,1.5,abs(cx)));',
    ' float lx=abs(p.x-cx);return uUp*flick(vec2(cx,k))*side*exp(-(p.y-FLO)*3.1)*1.62*exp(-lx*lx*1.6);}',
    'float amb(vec3 p){return uHaze*(.05+.68*smoothstep(-.2,3.3,p.y))*(.5+.5*smoothstep(4.5,1.,abs(p.x)));}',
    'vec2 surf(vec3 p,vec4 m,float k){float id=m.x;float alt=0.;if(id>3.5&&id<5.5){float a=atan(m.z,m.w);alt=mod(floor(a/6.2831853*(id<4.5?23.:19.)+.5),2.);}',
    ' float tx=.88+.12*n2(p.xy*vec2(11.,5.)+k*7.3);float ua=upl(p,k);',
    ' float E=amb(p)+win(p)*uShaft*1.2;vec2 c;',
    ' if(id==1.){float cyl=sqrt(max(1.-(1.-m.y)*(1.-m.y),0.));float flu=.86+.14*sin(m.y*19.);',
    '  c=vec2(.3*tx*cyl*flu*E,ua*(.18+.82*cyl*cyl)*flu*1.1);}',
    ' else if(id==2.){float cv=.55+.45*step(.5,fract(m.y*3.));c=vec2(.8*tx*E*(.55+.45*m.y)*cv,ua*.8);}',
    ' else if(id==3.){float cyl=.5+.5*m.y;float bd=step(.86,fract(p.y*4.2));c=vec2(.46*tx*cyl*(1.-.35*bd)*E,ua*.5*cyl);}',
    ' else if(id==4.||id==5.){float lip=1.-smoothstep(.0,.2,m.y)*smoothstep(1.,.78,m.y);float sc=id==4.?1.:.8;',
    '  if(alt>.5)c=vec2(.03*E,(uStripe*.3+.08*lip)*tx*E*sc+ua*1.1);',
    '  else c=vec2((.6+.2*lip)*tx*E*sc,ua*.6);}',
    ' else if(id==6.){float ash=step(.9,fract(p.y*2.6))+step(.94,fract(p.x*1.3+floor(p.y*2.6)*.5));c=vec2(.2*tx*(1.-.45*min(ash,1.))*E,ua*.2);}',
    ' else{float bm=step(.82,fract(p.z*1.6));c=vec2(.05*(1.-.6*bm)*E,0.);}',
    ' return c;}',
    'vec2 soff(vec3 p,float k){float tx=.75+.25*n2(p.xz*7.+k);return vec2(.22*tx*(amb(p)+win(p)*uShaft*.7),upl(p,k)*.4);}',
    'float fogT(float t){return exp(-t*uFogD);}',
    /* the far end: one cold cross in the dark; on the eclipse chapter it goes black with a blood rim */
    'vec2 far(vec3 rd){vec2 q=rd.xy/max(rd.z,.05);float r=length(q*vec2(1.,.8));',
    /* a tall arched doorway of light at the end of the aisle; the cross is its dark mullion */
    ' vec2 dq=q-vec2(0.,.004);float dd=dq.y<.022?max(abs(dq.x)-.017,abs(dq.y+.018)-.04):length(dq-vec2(0.,.022))-.017;',
    ' float inD=step(dd,0.);float mul=step(min(max(abs(dq.x)-.0026,abs(dq.y-.006)-.03),max(abs(dq.x)-.012,abs(dq.y-.018)-.0026)),0.);',
    ' float halo=exp(-max(dd,0.)*70.);',
    ' vec2 c=vec2(uHaze*(.03*exp(-r*4.)+.018*exp(-r*.8)),0.);',
    ' c+=vec2((1.25*inD*(1.-mul*.93)*(.85+.15*smoothstep(-.02,.03,-dq.y))+.3*halo),0.)*(1.-uEclipse)*uDoor;',
    ' c+=vec2(0.,(1.1*exp(-abs(dd)*320.)+.3*halo)*uEclipse);',
    ' return c;}',
    /* walk the stack of arcade walls */
    'vec2 trace(vec3 ro,vec3 rd,float tmax,int N,int NB,out float th){float k0=floor(ro.z/SP)+1.;',
    ' vec4 hm=vec4(0.);vec3 hp=ro;float hk=0.;float kind=0.;th=1e4;',
    ' for(int i=0;i<9;i++){if(i>=N)break;float k=k0+float(i);float z=k*SP;float t=(z-ro.z)/rd.z;if(t>tmax)break;',
    '  vec3 p=ro+rd*t;vec4 m=arc(vec2(mod(p.x+CX*.5,CX)-CX*.5,p.y));',
    '  if(m.x>.5){th=t;hm=m;hp=p;hk=k;kind=1.;break;}',
    '  if(i<NB){float t2=(z+DEP-ro.z)/rd.z;vec3 p2=ro+rd*t2;vec4 m2=arc(vec2(mod(p2.x+CX*.5,CX)-CX*.5,p2.y));',
    '  if(m2.x>.5&&t2<tmax){th=t2;hp=mix(p,p2,.5);hk=k;kind=2.;break;}}',
    ' }',
    ' if(kind>1.5)return soff(hp,hk);if(kind>.5)return surf(hp,hm,hk);return far(rd);}',
    /* the floor is black stone under a skin of water: a dark mirror */
    'vec2 floorc(vec3 pf,vec3 rd){vec2 g=pf.xz;vec2 nrm=vec2(0.);float ring=0.;',
    ' for(int i=0;i<4;i++){vec4 R=uRip[i];float a=uTime-R.z;if(a>0.&&a<3.2){vec2 d=(g-R.xy)*vec2(1.,1.);float r=length(d)+.001;float f=a*.6;',
    '  float w=exp(-abs(r-f)*24.)*exp(-a*1.05)*R.w;nrm+=d/r*sin((r-f)*40.)*w*.06;ring+=(smoothstep(.03,.0,abs(r-f))+.5*smoothstep(.03,.0,abs(r-f*.72)))*exp(-a*.95)*R.w;}}',
    ' nrm+=vec2(sin(g.x*1.7+uTime*.4+g.y*.6),cos(g.y*1.3-uTime*.35))*.0022;',
    ' vec3 rr=normalize(vec3(rd.x+nrm.x,-rd.y,rd.z+nrm.y));float th;',
    ' vec2 rf=trace(pf+vec3(0.,.001,0.),rr,60.,3,0,th);if(th<1e3)rf*=fogT(th);',
    ' float fr=.42+.58*pow(1.-abs(rd.y),3.);',
    ' vec2 cc=vec2(floor(g.x/CX)*CX+CX*.5,floor(g.y/SP+.5)*SP);float dc=length((g-cc)*vec2(1.,1.5));',
    ' float side=mix(.22,1.,smoothstep(3.,1.5,abs(cc.x)));',
    ' float pool=uUp*flick(vec2(cc.x,floor(g.y/SP+.5)))*side*exp(-dc*4.8);',
    ' vec2 fg=abs(fract(g*vec2(.83,.62))-.5);float ln=1.-.5*step(.47,max(fg.x,fg.y));',
    ' vec2 qx=rr.xy/max(rr.z,.05);float stk=exp(-abs(qx.x)*70.)*exp(-abs(qx.y)*7.)*(1.-uEclipse*.8)*uDoor;',
    ' vec2 c=vec2(.008*ln,0.)+rf*fr*.62+vec2(win(pf)*uShaft*.13*ln,pool)+vec2(ring*.22+stk*.35,stk*.12*uEclipse);',
    ' if(uPort.z>.001)c.y+=uPort.z*.5*exp(-length(vec2(pf.x*1.1,(pf.z-uPort.x)*1.6))*1.4);',
    ' return c;}',
    'void main(){vec2 fc=gl_FragCoord.xy;vec2 uv=(fc-.5*uRes)/(.5*uRes.y);',
    ' float yaw=uLook.x*.07;vec3 ro=vec3(uLook.x*.2,.06+uLook.y*.1,uZ);',
    ' vec3 rd=normalize(vec3(uv.x+uShift,uv.y+PITCH,FL));rd.xz=mat2(cos(yaw),-sin(yaw),sin(yaw),cos(yaw))*rd.xz;',
    ' float tf=rd.y<0.?(FLO-ro.y)/rd.y:1e4;float th;',
    ' vec2 c=trace(ro,rd,tf,9,3,th);',
    ' if(th>1e3&&tf<1e3){th=tf;c=floorc(ro+rd*tf,rd);}',
    ' float T=th>1e3?1.:fogT(th);c*=T;',
    ' vec2 a0=rd.xy/rd.z;float ra=length(a0*vec2(1.,.8));c+=vec2(uHaze*(.008+.075*exp(-ra*2.6)),uHaze*.004)*(1.-T);',
    /* shafts in the air, sampled along the view ray with a dithered offset; dust glints drift through them */
    ' float jt=by8(fc+vec2(3.,5.));float acc=0.;float tm=min(th,18.);',
    ' float NS=floor(5.+3.*uQ);for(int i=0;i<8;i++){if(float(i)>=NS)break;float s=(float(i)+jt)/NS;float ts=.6+s*s*tm;vec3 ps=ro+rd*ts;float w=win(ps)*step(ps.y,CEIL);',
    '  acc+=w*(2.*s*tm/NS)*exp(-ts*.07)*(.3+.7*smoothstep(FLO,FLO+2.4,ps.y))*smoothstep(1.,3.5,ts);}',
    ' float mote=step(.9965,h2(floor(fc*.5)+floor(vec2(uTime*3.,uTime*2.1))))*step(.02,acc);',
    ' c.x+=acc*uShaft*.3+mote*.45;',
    ' c.x+=uFlash*.35;',
    ' float vg=smoothstep(1.9,.3,length(uv*vec2(.58,.9)));c*=.15+.85*vg;',
    /* two ramps: ordered dither between steps and between ramps */
    /* a palette change runs down the hall, plane by plane, toward the doorway: the old light dies a step ahead of the front,
       the new light ignites behind it and the column fires flare as it passes. Light only - no particles, no flash */
    ' float b1=by8(fc);float b2=by8(fc.yx+vec2(5.,2.));float old=0.;',
    ' if(uWave.w>0.){float e=min(th,uWave.w)-uWave.x+(n2(fc*.03)-.5)*uWave.y*.3;',
    '  old=e+(b1-.5)*uWave.y*1.1>0.?1.:0.;',
    '  float ah=old*exp(-max(e,0.)/uWave.y);float bh=(1.-old)*exp(min(e,0.)/(uWave.y*1.7));',
    '  c*=1.-uWave.z*.75*ah;c.y*=1.+uWave.z*1.7*bh;c.x*=1.+uWave.z*.28*bh;}',
    ' c=max(c-.006,0.);float L=c.x+c.y;float pa=c.y/(L+1e-4);',
    ' float lv=pow(clamp(L,0.,1.),.6)*7.;float idx=clamp(floor(lv+.5+(b1-.5)*.72),0.,7.);',
    ' float row=step(b2,smoothstep(.14,.72,pa))+2.*old;',
    ' gl_FragColor=vec4(texture2D(uRamp,vec2((idx+.5)/8.,(row+.5)/4.)).rgb,1.);}'
  ].join('\n');
  const RAMP = {
    bone: '040303 0d0b0a 1b1716 2f2926 4b433e 7a7068 b2a797 ece4d6',
    blood: '060102 150304 2a0507 48080c 6f0c11 9e141a d02a24 ff5b3d',
    ice: '02040a 060c18 0c1a2e 153049 24506e 3f7fa0 79b8d2 d8f2ff',
    amber: '070301 160802 2c1004 4d1d06 78300a a94d12 dc7a24 ffc15a',
    steel: '030405 0a0c0e 15191c 252b30 3d454c 636d76 9ba5ad e0e6ea',
    ash: '040303 0c0a0a 181515 292423 403937 655c58 978c85 d8cfc6'
  };
  const rampOf = k => RAMP[k].split(' ').map(h => [0, 2, 4].map(i => parseInt(h.substr(i, 2), 16)));
  const WPAL = {
    blood: { a: 'bone', b: 'blood', up: 1, shaft: 1, haze: 1, ecl: 0, stripe: 1, fog: 0.08 },
    bone: { a: 'bone', b: 'blood', up: 0.55, shaft: 1.25, haze: 1.15, ecl: 0, stripe: 0.8, fog: 0.075 },
    fire: { a: 'ash', b: 'amber', up: 1.2, shaft: 0.75, haze: 1.2, ecl: 0, stripe: 1, fog: 0.08 },
    steel: { a: 'steel', b: 'blood', up: 0.7, shaft: 1.1, haze: 0.95, ecl: 0, stripe: 0.85, fog: 0.08 },
    holy: { a: 'steel', b: 'ice', up: 0.95, shaft: 1.4, haze: 1.35, ecl: 0, stripe: 0.9, fog: 0.07 },
    moon: { a: 'bone', b: 'blood', up: 1.15, shaft: 0.35, haze: 0.7, ecl: 1, stripe: 1, fog: 0.095 }
  };
  WPAL.flavor = WPAL.blood; WPAL.ice = WPAL.holy; WPAL.pop = WPAL.holy; WPAL.ash = WPAL.steel;
  /* a flavour colour becomes its own 8-step ramp: black, through the colour, to a hot highlight */
  const rampFrom = c => [0.02, 0.06, 0.13, 0.24, 0.4, 0.62, 0.86, 1].map((v, i) => c.map(x => Math.round(Math.min(255, (x * v + (i === 7 ? (1 - x) * 0.45 : 0)) * 255))));
  /* ---------- The change you feel: as the new light reaches each column, its fire throws embers up into the hall ----------
     Every ember is a pure function of its seed and the time since the change: no CPU work per frame.
     A quarter of them hang in the air right in front of the viewer; when a flavour card was tapped, some rise out of the card itself.
     Each is drawn twice: a pixel head, and a short streak back to where it was a moment ago. */
  const PVS = [
    'attribute vec4 aS;attribute float aE;',
    'uniform vec2 uLook;uniform float uT,uZ,uZ0,uShift,uAsp,uK,uPx,uMode,uFrac;uniform vec3 uFrom;',
    'varying float vA,vH;',
    'const float FL=1.55,PITCH=.16,SP=2.6,CX=2.4,FLO=-1.;',
    'float h1(float n){return fract(sin(n)*43758.5453);}',
    'void main(){vA=0.;vH=0.;gl_PointSize=1.;gl_Position=vec4(2.,2.,0.,1.);',
    ' float r1=h1(aS.x*91.7+aS.y*13.1),r2=h1(aS.z*57.3+aS.w*7.9),r3=h1(aS.w*33.3+aS.x*3.3);',
    /* the column embers live in the hall (mode 0); the air motes and the card embers fly over the page (mode 1) */
    ' float col=(aS.w<.26||(uFrom.z>.5&&aS.w<.6))?0.:1.;if(abs(col-(1.-uMode))>.5)return;',
    /* only a share of the embers takes part: a tap gets a real burst, a scroll only a trace */
    ' if(fract(aS.x*37.13+aS.y*11.7+aS.w*3.1+aS.z*5.9)>uFrac)return;',
    ' vec3 s;vec3 v;float b;float L;float k=1.;float big=1.;float tl=.45;',
    ' if(uFrom.z>.5&&aS.w>.26&&aS.w<.6){float dz=1.1+aS.z*1.3;vec2 sc=uFrom.xy+(aS.xy-.5)*vec2(.34,.2);',
    '  s=vec3((sc.x*uAsp+uShift)*dz/FL,(sc.y+PITCH)*dz/FL+.06,uZ0+dz);v=vec3((r1-.5)*1.9,.35+r2*1.9,(r3-.1)*1.4);b=r3*.22;L=1.7+r1*1.3;tl=1.;k=1.25;big=1.25;}',
    ' else if(aS.w<.26){float dz=.9+aS.z*3.;s=vec3((aS.x*2.-1.)*(1.+dz*.7),-.9+aS.y*3.4,uZ0+dz);',
    '  v=vec3((r1-.5)*.9,.2+r2*.7,.3+r3*.9);b=.05+aS.y*.55;L=1.9+r1*1.2;k=.8;big=1.5;tl=1.;}',
    ' else{float j=floor(aS.z*12.);float zc=(floor(uZ0/SP)+1.+j)*SP;float d=zc-uZ0;float sd=aS.x<.5?-1.:1.;',
    '  float xc=sd*(CX*.5+step(.7,fract(aS.x*2.))*CX);',
    '  b=2.2*max(0.,(-13.608+sqrt(max(0.,185.18-139.968*(2.2-d))))/69.984)+r3*.2;',
    '  s=vec3(xc+(r1-.5)*.4,FLO+.04+r2*.22,zc+(r3-.5)*.34);v=vec3((r1-.5)*1.1,1.5+r2*2.3,(r3-.35)*.7);L=1.2+r2*1.4;}',
    ' float h=uT-b;if(h<0.||h>L)return;float a=max(h-aE*.04,0.);',
    /* hall embers climb and slow; embers over the page burst out with drag, then float up on a slow swirl */
    ' vec3 q=col>.5?s+v*(a-.3*a*a/L)+vec3(sin(a*3.1+r1*40.)*.2,0.,cos(a*2.3+r2*30.)*.12)*a:s+v*(1.-exp(-a*2.6))/2.6+vec3(sin(a*1.7+r1*40.)*.16,.22+.1*sin(a*2.3+r2*20.),.12)*a;',
    ' float yw=uLook.x*.07;vec3 r=q-vec3(uLook.x*.2,.06+uLook.y*.1,uZ);float X=cos(yw)*r.x-sin(yw)*r.z,Z=sin(yw)*r.x+cos(yw)*r.z;',
    ' if(Z<.12)return;gl_Position=vec4((X/Z*FL-uShift)/uAsp,r.y/Z*FL-PITCH,0.,1.);',
    ' vA=1.3*k*smoothstep(0.,.05,h)*(1.-smoothstep(.55,1.,h/L))*exp(-Z*.04)*uK*(1.-aE*tl)*(.72+.28*sin(uT*23.+r1*50.));',
    ' vH=step(.8,fract(r1*7.13+r2*3.71));gl_PointSize=clamp((3.4+uMode*.8)/Z,1.+uMode*.5,3.+uMode)*big*uPx;}'
  ].join('\n');
  const PFS = 'precision mediump float;varying float vA,vH;uniform vec3 uC1,uC2;void main(){vec3 c=min(mix(uC1,uC2,vH),1.);gl_FragColor=vec4(c*vA,vA);}';
  class Embers {
    constructor(gl, mode) {
      const sh = (type, src) => { const x = gl.createShader(type); gl.shaderSource(x, src); gl.compileShader(x); if (!gl.getShaderParameter(x, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(x) || 'pshader'); return x; };
      const pp = gl.createProgram(); gl.attachShader(pp, sh(gl.VERTEX_SHADER, PVS)); gl.attachShader(pp, sh(gl.FRAGMENT_SHADER, PFS)); gl.linkProgram(pp);
      if (!gl.getProgramParameter(pp, gl.LINK_STATUS)) throw new Error('plink');
      const n = matchMedia('(max-width: 749px)').matches ? 600 : 1000, d = new Float32Array(n * 10);
      for (let i = 0; i < n; i++) { const r = [Math.random(), Math.random(), Math.random(), Math.random()]; for (let e = 0; e < 2; e++) { const k = (i * 2 + e) * 5; d[k] = r[0]; d[k + 1] = r[1]; d[k + 2] = r[2]; d[k + 3] = r[3]; d[k + 4] = e; } }
      const prev = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
      this.pb = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, this.pb); gl.bufferData(gl.ARRAY_BUFFER, d, gl.STATIC_DRAW); gl.bindBuffer(gl.ARRAY_BUFFER, prev);
      this.gl = gl; this.n = n; this.pp = pp; this.mode = mode; this.u = {};
      ['uLook', 'uT', 'uZ', 'uZ0', 'uShift', 'uAsp', 'uK', 'uPx', 'uMode', 'uFrac', 'uFrom', 'uC1', 'uC2'].forEach(k => { this.u[k] = gl.getUniformLocation(pp, k); });
      this.aS = gl.getAttribLocation(pp, 'aS'); this.aE = gl.getAttribLocation(pp, 'aE');
    }
    draw(o) {
      const gl = this.gl, u = this.u, fr = (this.mode ? o.air : o.hall * (TIER.lite ? 0.8 : 1));
      if (!(fr > 0)) return;
      gl.useProgram(this.pp); gl.bindBuffer(gl.ARRAY_BUFFER, this.pb);
      gl.enableVertexAttribArray(this.aS); gl.enableVertexAttribArray(this.aE);
      gl.uniform2f(u.uLook, o.look[0], o.look[1]); gl.uniform1f(u.uT, o.t); gl.uniform1f(u.uZ, o.z); gl.uniform1f(u.uZ0, o.z0);
      gl.uniform1f(u.uShift, o.shift); gl.uniform1f(u.uAsp, o.asp); gl.uniform1f(u.uPx, o.px); gl.uniform1f(u.uK, o.k); gl.uniform1f(u.uMode, this.mode); gl.uniform1f(u.uFrac, fr);
      const f = o.from; gl.uniform3f(u.uFrom, f ? f[0] : 0, f ? f[1] : 0, f ? 1 : 0);
      gl.uniform3f(u.uC1, o.c[0][0], o.c[0][1], o.c[0][2]); gl.uniform3f(u.uC2, o.c[1][0], o.c[1][1], o.c[1][2]);
      gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE);
      /* streaks: head + tail of every ember */
      if (!this.mode) { gl.vertexAttribPointer(this.aS, 4, gl.FLOAT, false, 20, 0); gl.vertexAttribPointer(this.aE, 1, gl.FLOAT, false, 20, 16); gl.drawArrays(gl.LINES, 0, this.n * 2); }
      /* heads only: step over every tail vertex */
      gl.vertexAttribPointer(this.aS, 4, gl.FLOAT, false, 40, 0); gl.vertexAttribPointer(this.aE, 1, gl.FLOAT, false, 40, 16);
      gl.drawArrays(gl.POINTS, 0, this.n);
      gl.disable(gl.BLEND); gl.disableVertexAttribArray(this.aS); gl.disableVertexAttribArray(this.aE);
    }
  }
  /* a transparent pane over the page, alive only while a change runs: the embers that should be felt, not just seen */
  class Veil {
    constructor(canvas) {
      const gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, depth: false, stencil: false, preserveDrawingBuffer: false });
      if (!gl) throw new Error('webgl');
      this.gl = gl; this.c = canvas; this.em = new Embers(gl, 1); this.on = false;
    }
    frame(o, dev) {
      const gl = this.gl, c = this.c;
      if (gl.isContextLost()) return;
      if (!o || !(o.air > 0)) { if (this.on) { gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); c.style.visibility = 'hidden'; this.on = false; this.r = null; } return; }
      if (!this.on || !this.r) this.r = c.getBoundingClientRect();
      const r = this.r, dpr = window.devicePixelRatio || 1;
      const W = Math.max(2, Math.round(r.width * dpr / dev)), H = Math.max(2, Math.round(r.height * dpr / dev));
      if (c.width !== W || c.height !== H) { c.width = W; c.height = H; gl.viewport(0, 0, W, H); }
      if (!this.on) { c.style.visibility = 'visible'; this.on = true; }
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      const f = o.from ? [(o.from.x - r.left) / r.width * 2 - 1, 1 - (o.from.y - r.top) / r.height * 2] : null;
      /* the pane is anchored to the eye, not the hall: scrolling never leaves its embers behind the camera */
      this.em.draw(Object.assign({}, o, { asp: W / H, shift: 0, from: f, z: 0, z0: 0 }));
    }
  }
  class World {
    constructor(canvas) {
      const gl = canvas.getContext('webgl', { antialias: false, alpha: false, depth: false, stencil: false, premultipliedAlpha: false, preserveDrawingBuffer: false });
      if (!gl) throw new Error('webgl');
      this.calm = matchMedia('(prefers-reduced-motion: reduce)').matches; this.pt = -1; this.kick = 0; this.pFrom = null; this.pc = [[1, 0.2, 0.2], [1, 1, 1]];
      this.fx = null; this.em = null; this.ok = false;
      this.gl = gl; this.c = canvas; this.dev = 2; this.deg = 0; this.q = 1; this.target = 1 / 60; this.shift = 0; this.door = 1; this.doorC = 1; this.lz = -1; this.lx = 0; this.ly = 0; this.odd = false; this.w = 0; this.h = 0;
      this.devMax = Math.ceil((window.devicePixelRatio || 1) * 2.2);
      this.z = 0; this.vel = 0; this.look = [0, 0]; this.flash = 0; this.time = 0; this.port = [0, 0.8, 0];
      this.rips = new Float32Array(16).fill(-99); this.ri = 0;
      this.cur = this.pal('blood'); this.tgt = this.pal('blood'); this.old = null; this.wave = null; this.fresh = true; this.dirty = true; this.ema = 1 / 60; this.n = 0; this.slow = 0; this.born = performance.now(); this.lt = 0; this.half = false; this.hf = false;
      this.kx = gl.getExtension('KHR_parallel_shader_compile');
      this.job = shaderStart(gl, WFS);
      if (!this.kx && !this.finish()) throw new Error('shader');
      gpuCheck(gl);
      WORLDS.push(this);
      if (TIER.lite) this.toLite();
    }
    /* the hall's program is ready: look up its inputs once. Until then draw() is a no-op and the page keeps scrolling */
    finish() {
      if (this.ok) return true;
      if (this.dead) return false;
      const gl = this.gl;
      if (this.kx && !gl.getProgramParameter(this.job.pr, this.kx.COMPLETION_STATUS_KHR)) return false;
      let pr;
      try { shaderProgram(gl, WFS, this.job); pr = gl.getParameter(gl.CURRENT_PROGRAM); } catch (e) { this.dead = true; const a = this.c.closest('.sx-armed'); if (a) a.classList.remove('sx-armed'); this.c.style.visibility = 'hidden'; return false; }
      this.pr = pr; this.qb = gl.getParameter(gl.ARRAY_BUFFER_BINDING); this.qloc = gl.getAttribLocation(pr, 'p');
      try { this.em = new Embers(gl, 0); } catch (e) { this.em = null; }
      gl.useProgram(pr);
      this.u = {};
      ['uRes', 'uTime', 'uZ', 'uVel', 'uFlash', 'uUp', 'uShaft', 'uHaze', 'uEclipse', 'uStripe', 'uFogD', 'uQ', 'uShift', 'uDoor', 'uLook', 'uRip', 'uPort', 'uWave', 'uRamp'].forEach(n => { this.u[n] = gl.getUniformLocation(pr, n); });
      this.tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, this.tex);
      [[gl.TEXTURE_MIN_FILTER, gl.NEAREST], [gl.TEXTURE_MAG_FILTER, gl.NEAREST], [gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE], [gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE]].forEach(([k, v]) => gl.texParameteri(gl.TEXTURE_2D, k, v));
      gl.uniform1i(this.u.uRamp, 0);
      this.dirty = true; this.ok = true; this.born = performance.now();
      return true;
    }
    /* weak device: one step bigger grain, every other frame, near embers drawn in this same context */
    toLite() {
      if (this.lite) return;
      this.lite = true; this.half = true; this.target = 1 / 30; this.n = 0; this.slow = 0;
      if (this.deg < 1) { this.deg = 1; if (this.w) this.size(this.w, this.h); }
    }
    /* the pane over the page that carries the near embers */
    /* created only the first time a change actually sends embers over the page: no second GL context until it is needed */
    attachVeil(canvas) { if (!this.calm && canvas) this.fxc = canvas; }
    pal(p) {
      const P = typeof p === 'string' ? (WPAL[p] || WPAL.blood) : WPAL.blood;
      const rb = typeof p === 'string' ? rampOf(P.b) : rampFrom(p && p.accent ? p.accent : [0.9, 0.1, 0.1]);
      return { ra: rampOf(P.a), rb, up: P.up, shaft: P.shaft, haze: P.haze, ecl: P.ecl, stripe: P.stripe, fog: P.fog };
    }
    /* a new palette does not fade: it runs down the hall from the viewer to the doorway, relighting every arcade it passes */
    palette(p, from, fx) {
      const t = this.pal(p);
      if (this.fresh) { this.fresh = false; this.cur = this.pal(p); this.tgt = t; this.dirty = true; return; }
      const same = JSON.stringify(t.ra) === JSON.stringify(this.cur.ra) && JSON.stringify(t.rb) === JSON.stringify(this.cur.rb);
      this.tgt = t;
      if (same) return;
      this.old = { ra: this.cur.ra, rb: this.cur.rb };
      this.cur.ra = t.ra.map(c => c.slice()); this.cur.rb = t.rb.map(c => c.slice());
      /* how much the change shows: a tap (default) bursts, a first visit by scroll leaves a trace, a return only relights the hall */
      const L = Object.assign({ hall: 0.6, air: 0.55, flare: 1, kick: 1 }, fx || {});
      this.wave = { t: 0, flare: L.flare };
      this.dirty = true;
      /* the embers take the new colour: its hot step, and its white-hot top for one in five */
      if (!this.calm && (L.hall > 0 || L.air > 0)) {
        if (L.air > 0 && !this.fx && this.fxc && !this.lite) { try { this.fx = new Veil(this.fxc); } catch (e) { this.fxc = null; } }
        const hot = t.rb[6].map(v => v / 255), top = t.rb[7].map(v => Math.min(1, v / 255 * 1.1));
        this.pc = [hot.map(v => v * 1.15), top]; this.pt = 0; this.pz0 = this.z; this.pFrom = from || null; this.pL = L;
      }
    }
    /* a drop lands: rings spread on the flooded floor where it fell */
    ripple(x, z, amp = 1) { const i = (this.ri++ % 4) * 4; this.rips[i] = x; this.rips[i + 1] = z; this.rips[i + 2] = this.time; this.rips[i + 3] = amp; }
    /* one world pixel = a whole number of device pixels, about 1/960 of the screen width: fine grain on a phone, the same grain on a monitor */
    size(w, h) {
      this.w = w; this.h = h;
      const dpr = window.devicePixelRatio || 1;
      this.dev = Math.min(this.devMax, Math.max(Math.ceil(dpr - 0.05), Math.round(dpr * w / 960), 1) + this.deg);
      const W = Math.max(2, Math.round(w * dpr / this.dev)), H = Math.max(2, Math.round(h * dpr / this.dev));
      if (this.c.width !== W || this.c.height !== H) { this.c.width = W; this.c.height = H; this.gl.viewport(0, 0, W, H); }
    }
    step(dt) {
      const a = 1 - Math.exp(-dt * 2.6), c = this.cur, t = this.tgt;
      let moved = false;
      ['up', 'shaft', 'haze', 'ecl', 'stripe', 'fog'].forEach(k => { const d = t[k] - c[k]; if (Math.abs(d) > 1e-4) { c[k] += d * a; moved = true; } else c[k] = t[k]; });
      if (Math.abs(this.door - this.doorC) > 0.002) { this.doorC += (this.door - this.doorC) * a; moved = true; }
      if (this.wave) { this.wave.t += dt / 2.2; moved = true; if (this.wave.t >= 1) { this.wave = null; this.old = null; this.dirty = true; } }
      if (this.pt >= 0) { this.pt += dt; moved = true; const k = this.pt; this.kick = 0.32 * (this.pL ? this.pL.kick : 1) * (1 - Math.exp(-k * 7)) * Math.exp(-k * 1.5); if (k > 3.4) { this.pt = -1; this.kick = 0; } }
      if (moved) this.lz = -1;
      /* self-tuning, on the real frame interval: a device that cannot hold its rate goes lite (bigger grain, every other frame,
         lighter page), then bigger pixels, then fewer light samples. It decides within about a second, after a short settle-in
         so a busy page load is not mistaken for a weak phone. Same picture, same motion. */
      const now = performance.now(), raw = this.lt ? Math.min(0.25, (now - this.lt) / 1000) : this.target; this.lt = now;
      if (!this.ok || document.hidden) return;
      this.ema += (raw - this.ema) * 0.08;
      if (now - this.born < 3500) { this.slow = 0; return; }
      if (++this.n > 24 && this.ema > this.target * 1.55) {
        if (++this.slow > 20) {
          this.slow = 0; this.n = 0;
          if (!this.lite && !TIER.forced) goLite();
          else if (this.deg < 2 && this.dev < this.devMax) { this.deg++; this.size(this.w, this.h); }
          else if (this.q > 0) this.q = Math.max(0, this.q - 0.5);
          this.ema = this.target;
        }
      } else this.slow = 0;
    }
    draw() {
      const gl = this.gl, c = this.cur;
      if (gl.isContextLost() || (!this.ok && !this.finish())) return;
      const u = this.u;
      /* while the camera rests, only candle flicker and dust move: every other frame is enough */
      const still = Math.abs(this.z - this.lz) < 1e-4 && Math.abs(this.look[0] - this.lx) < 1e-4 && Math.abs(this.look[1] - this.ly) < 1e-4 && this.flash < 0.01 && !this.dirty;
      this.lz = this.z; this.lx = this.look[0]; this.ly = this.look[1];
      if (still && (this.odd = !this.odd)) return;
      if (this.dirty) {
        const d = new Uint8Array(128), o = this.old || c, rows = [c.ra, c.rb, o.ra, o.rb];
        for (let r = 0; r < 4; r++) for (let i = 0; i < 8; i++) { const col = rows[r][i], k = (r * 8 + i) * 4; d[k] = col[0]; d[k + 1] = col[1]; d[k + 2] = col[2]; d[k + 3] = 255; }
        gl.bindTexture(gl.TEXTURE_2D, this.tex); gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 8, 4, 0, gl.RGBA, gl.UNSIGNED_BYTE, d); this.dirty = false;
      }
      gl.uniform2f(u.uRes, this.c.width, this.c.height); gl.uniform1f(u.uQ, this.q); gl.uniform1f(u.uShift, this.shift); gl.uniform1f(u.uDoor, this.doorC * (this.w < 990 ? 0.42 : 1));
      gl.uniform1f(u.uTime, this.time); gl.uniform1f(u.uZ, this.z + this.kick); gl.uniform1f(u.uVel, this.vel); gl.uniform1f(u.uFlash, this.flash);
      /* the fires at the column feet beat like a slow heart: lub-dub, rest */
      const hp = this.time % 1.3, hb = Math.exp(-Math.pow(hp / 0.07, 2)) + 0.55 * Math.exp(-Math.pow((hp - 0.24) / 0.08, 2));
      gl.uniform1f(u.uUp, c.up * (1 + 0.11 * hb)); gl.uniform1f(u.uShaft, c.shaft); gl.uniform1f(u.uHaze, c.haze); gl.uniform1f(u.uEclipse, c.ecl); gl.uniform1f(u.uStripe, c.stripe); gl.uniform1f(u.uFogD, c.fog);
      gl.uniform2f(u.uLook, this.look[0], this.look[1]); gl.uniform4fv(u.uRip, this.rips); gl.uniform3f(u.uPort, this.port[0], this.port[1], this.port[2]);
      const wv = this.wave;
      /* the front accelerates away from the viewer into the vanishing point; its light fades out over the last quarter */
      if (wv) { const t = Math.min(1, wv.t), B = 2.6, F = 46; gl.uniform4f(u.uWave, 2.2 + (F + B) * (0.28 * t + 0.72 * t * t), B, Math.min(1, (1 - t) / 0.3) * (wv.flare == null ? 1 : wv.flare), F); } else gl.uniform4f(u.uWave, 0, 0, 0, -1);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      if (this.pt >= 0) {
        const o = { t: this.pt, z: this.z + this.kick, z0: this.pz0, look: this.look, shift: this.shift, asp: this.c.width / this.c.height, px: this.w && this.w < 750 ? 1.35 : Math.max(1, Math.round(this.c.width / 900)), k: Math.min(1, (3.4 - this.pt) / 0.8), c: this.pc, from: this.pFrom, hall: this.pL ? this.pL.hall : 0.6, air: this.pL ? this.pL.air : 0.55 };
        if (this.em) {
          this.em.draw(o);
          /* lite: the near embers ride in the hall's own context, anchored to the eye, instead of a second pane over the page */
          if (this.lite && !this.fx && this.fxc && o.air > 0 && this.em2 !== false) {
            if (!this.em2) { try { this.em2 = new Embers(gl, 1); } catch (e) { this.em2 = false; } }
            if (this.em2) {
              const r = this.vr || { left: 0, top: 0, width: this.w || innerWidth, height: this.h || innerHeight }, F = this.pFrom;
              this.em2.draw(Object.assign({}, o, { z: 0, z0: 0, shift: 0, from: F ? [(F.x - r.left) / r.width * 2 - 1, 1 - (F.y - r.top) / r.height * 2] : null }));
            }
          }
          gl.useProgram(this.pr); gl.bindBuffer(gl.ARRAY_BUFFER, this.qb); gl.enableVertexAttribArray(this.qloc); gl.vertexAttribPointer(this.qloc, 2, gl.FLOAT, false, 0, 0);
        }
        if (this.fx) this.fx.frame(o, this.dev);
      } else if (this.fx && this.fx.on) this.fx.frame(null);
    }
  }
  /* Same camera as the shader: world point -> CSS pixels of the view. */
  const project = (x, y, z, cam, vw, vh) => {
    const yaw = cam.look[0] * 0.07, rx = x - cam.look[0] * 0.2, ry = y - (0.06 + cam.look[1] * 0.1), rz = z - cam.z;
    const X = Math.cos(yaw) * rx - Math.sin(yaw) * rz, Z = Math.sin(yaw) * rx + Math.cos(yaw) * rz;
    if (Z <= 0.02) return null;
    const hh = vh / 2, k = FL / Z;
    return { x: vw / 2 + X * k * hh, y: hh - (ry * k - PITCH) * hh, s: k * hh, d: Z };
  };

  /* ---------- A relic that turns: cylindrical re-projection of a product render ---------- */
  const RELIC_FS = [
    'precision mediump float;varying vec2 v;',
    'uniform sampler2D uA,uB;uniform vec2 uGA,uGB,uTexel;uniform float uPhi,uWipe,uPad;uniform vec3 uAcc,uAccB;',
    'vec4 sm(sampler2D t,vec2 q){if(q.x<0.||q.x>1.||q.y<0.||q.y>1.)return vec4(0.);return texture2D(t,q);}',
    'vec4 cyl(sampler2D t,vec2 q,vec2 g,vec3 acc){float xn=(q.x-g.x)/g.y;vec4 c;',
    ' if(abs(xn)<1.){float th=asin(xn);float t2=th-uPhi;c=sm(t,vec2(g.x+sin(clamp(t2,-1.5707,1.5707))*g.y,q.y));',
    '  c.rgb*=smoothstep(1.8,1.25,abs(t2));',
    '  float sp=pow(max(cos(th-.62),0.),70.)*.55+pow(max(cos(th+1.02),0.),24.)*.14;',
    '  float rim=pow(abs(xn),14.);',
    '  c.rgb=c.rgb*mix(1.,.72,pow(abs(xn),3.))+(vec3(1.,.97,.95)*sp+acc*rim*.85)*c.a;',
    ' }else c=sm(t,q);return c;}',
    'float aura(sampler2D t,vec2 q){float a=0.;for(int i=0;i<8;i++){float an=float(i)*.7854;a+=sm(t,q+vec2(cos(an),sin(an))*uTexel*22.).a;}return a*.125;}',
    'void main(){vec2 q=vec2((v.x-uPad)/(1.-2.*uPad),(v.y-uPad*.5)/(1.-uPad));',
    ' vec4 a=cyl(uA,q,uGA,uAcc);vec4 c=a;vec3 ac=uAcc;',
    ' if(uWipe>0.){vec4 b=cyl(uB,q,uGB,uAccB);vec2 p=(q-vec2(.5,.02))/max(uWipe*1.7,.001);float w=.5,s=.5;',
    '  float d=p.y<=s?abs(p.x)-w:max(length(p-vec2(-w,s)),length(p-vec2(w,s)))-2.*w;d=max(d,-p.y);',
    '  float m=smoothstep(.015,-.015,d);c=mix(a,b,m);ac=mix(uAcc,uAccB,m);',
    '  c.rgb+=uAccB*exp(-abs(d)*38.)*(1.-uWipe)*1.8*max(a.a,b.a);}',
    ' float au=uWipe>.5?aura(uB,q):aura(uA,q);vec3 gw=ac*au*au*(1.-c.a)*.42;',
    ' gl_FragColor=vec4(c.rgb*c.a+gw,max(c.a,max(gw.r,max(gw.g,gw.b))));}'
  ].join('\n');
  class Relic {
    constructor(canvas) {
      const gl = canvas.getContext('webgl', { antialias: !TIER.lite, alpha: true, premultipliedAlpha: true, depth: false, stencil: false });
      if (!gl) throw new Error('webgl');
      const pr = shaderProgram(gl, RELIC_FS);
      this.u = {};
      ['uA', 'uB', 'uGA', 'uGB', 'uTexel', 'uPhi', 'uWipe', 'uPad', 'uAcc', 'uAccB'].forEach(n => { this.u[n] = gl.getUniformLocation(pr, n); });
      gl.uniform1i(this.u.uA, 0); gl.uniform1i(this.u.uB, 1);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
      gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      this.gl = gl; this.c = canvas; this.cache = new Map(); this.a = null; this.b = null; this.wipe = 0; this.phi = 0; this.pad = 0.07;
    }
    tex(url) {
      if (this.cache.has(url)) return this.cache.get(url);
      const job = new Promise((resolve, reject) => {
        const img = new Image();
        try { if (new URL(url, location.href).origin !== location.origin) img.crossOrigin = 'anonymous'; } catch (e) {}
        img.decoding = 'async';
        img.onload = () => {
          const gl = this.gl, t = gl.createTexture();
          gl.bindTexture(gl.TEXTURE_2D, t);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img); } catch (e) { reject(e); return; }
          let geo = [0.5, 0.35];
          try {
            const W = 160, H = Math.round(160 * img.naturalHeight / img.naturalWidth), cv = document.createElement('canvas');
            cv.width = W; cv.height = H; const cx = cv.getContext('2d'); cx.drawImage(img, 0, 0, W, H);
            const d = cx.getImageData(0, 0, W, H).data; let top = H, bot = 0;
            for (let y = 0; y < H; y++) for (let x = 0; x < W; x += 2) if (d[(y * W + x) * 4 + 3] > 128) { top = Math.min(top, y); bot = Math.max(bot, y); break; }
            const row = Math.round(top + (bot - top) * 0.55); let l = -1, r = -1;
            for (let x = 0; x < W; x++) if (d[(row * W + x) * 4 + 3] > 128) { if (l < 0) l = x; r = x; }
            if (l >= 0 && r > l) geo = [(l + r + 1) / 2 / W, (r - l + 1) / 2 / W];
          } catch (e) {}
          resolve({ t, geo, w: img.naturalWidth, h: img.naturalHeight });
        };
        img.onerror = reject;
        img.src = url;
      });
      this.cache.set(url, job);
      return job;
    }
    async show(url, acc) {
      const next = await this.tex(url);
      next.acc = acc;
      if (!this.a) { this.a = next; return; }
      if (this.a === next) return;
      this.b = next; this.wipe = 0.0001;
    }
    size() {
      const r = this.c.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, TIER.lite ? 1.5 : 2);
      const W = Math.max(2, Math.round(r.width * dpr)), H = Math.max(2, Math.round(r.height * dpr));
      if (this.c.width !== W || this.c.height !== H) { this.c.width = W; this.c.height = H; this.gl.viewport(0, 0, W, H); }
    }
    draw(dt) {
      const gl = this.gl, u = this.u;
      if (!this.a || gl.isContextLost()) return;
      if (this.b) { this.wipe = Math.min(1, this.wipe + dt / 0.9); if (this.wipe >= 1) { this.a = this.b; this.b = null; this.wipe = 0; } }
      const b = this.b || this.a;
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, this.a.t);
      gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, b.t);
      gl.uniform2f(u.uGA, this.a.geo[0], this.a.geo[1]); gl.uniform2f(u.uGB, b.geo[0], b.geo[1]);
      gl.uniform2f(u.uTexel, 1 / this.a.w, 1 / this.a.h);
      gl.uniform1f(u.uPhi, this.phi); gl.uniform1f(u.uWipe, this.b ? this.wipe : 0); gl.uniform1f(u.uPad, this.pad);
      gl.uniform3fv(u.uAcc, this.a.acc || [1, 0.1, 0.1]); gl.uniform3fv(u.uAccB, b.acc || [1, 0.1, 0.1]);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
  }

  /* ---------- Text decode ---------- */
  const GLYPHS = '†✠‡⸸#%&/<>|01ΔΣ';
  const decode = (el, text) => {
    const target = text != null ? text : (el.dataset.sxText || el.textContent);
    el.dataset.sxText = target;
    clearInterval(el._sxT);
    let f = 0; const steps = 16;
    el._sxT = setInterval(() => {
      f++;
      const shown = Math.floor(target.length * f / steps);
      el.textContent = target.split('').map((ch, i) => (ch === ' ' || i < shown) ? ch : GLYPHS[(Math.random() * GLYPHS.length) | 0]).join('');
      if (f >= steps) { clearInterval(el._sxT); el.textContent = target; }
    }, 42);
  };
  const CAPS = ['Limen', 'Reliquia', 'Dosis', 'Legenda', 'Arma', 'Aqua Sancta', 'Confessio', 'Resurgam'];
  const AREAS = [null, ['Capitulum I', 'Reliquia', 'The relic'], ['Capitulum II', 'Dosis', 'Five doses, all disclosed'], ['Capitulum III', 'Legenda', 'The legend awaits'], ['Capitulum IV', 'Arma', 'The armory'], ['Capitulum V', 'Aqua Sancta', 'Sealed chapter'], ['Codex', 'Confessio', 'Lore entries'], null];
  const headerBottom = () => {
    const h = document.querySelector('.section-header');
    if (!h) return 0;
    const cs = getComputedStyle(h);
    /* Resting bottom of the pinned header (announcement bar scrolls away above it). */
    if (cs.position === 'sticky') return Math.max(0, Math.round((parseFloat(cs.top) || 0) + h.offsetHeight));
    return cs.position === 'fixed' ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
  };

  const init = (scope = document) => scope.querySelectorAll('[data-sx]').forEach(root => {
    if (root.dataset.sxReady) return;
    root.dataset.sxReady = '1';
    const abort = new AbortController(); const signal = abort.signal;
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    const mobileQ = matchMedia('(max-width: 749px)');
    /* the gear cases and the full-set slots look out through the hall's own arches */
    root.querySelectorAll('.sx-exhibit__stage').forEach(st => archFrame(st, st.querySelector('.sx-niche__win'), { pad: 16, gap: 7, tick: 6, bottom: 16, cls: 'sxa--exhibit' }));
    root.querySelectorAll('.sx-loadout__win').forEach(wn => archFrame(wn, wn.querySelector('img'), { pad: 3, gap: 3, tick: 2, bottom: 3, cls: 'sxa--slot' }));
    const chapters = [...root.querySelectorAll('[data-sx-ch]')];
    const rail = root.querySelector('[data-sx-rail]');
    const railLinks = rail ? [...rail.querySelectorAll('[data-sx-to]')] : [];
    const railFill = rail && rail.querySelector('[data-sx-rail-fill]');
    let active = -1;
    const setTop = () => {
      const hb = headerBottom();
      root.style.setProperty('--sx-top', hb + 'px');
      /* first paint: the announcement bar still sits above the pinned header */
      const t0 = Math.round(root.getBoundingClientRect().top + scrollY);
      root.style.setProperty('--sx-top0', (t0 > hb && t0 < 260 ? t0 : hb) + 'px');
    };
    setTop();

    /* Rail + chapter tracking (both live and still modes). */
    const track = (vh, R) => {
      let idx = 0;
      for (let i = 0; i < chapters.length; i++) if ((R ? R.ch[i] : chapters[i].getBoundingClientRect().top) < vh * 0.55) idx = +chapters[i].dataset.sxCh;
      if (rail) {
        const r = R ? R.root : root.getBoundingClientRect();
        rail.classList.toggle('is-shown', idx >= 1 && r.bottom > vh * 1.2);
        let fill = 0;
        railLinks.forEach(a => { const n = +a.dataset.sxTo; a.classList.toggle('is-active', n === idx); if (idx >= n) fill = (n - 1) / Math.max(1, railLinks.length - 1); });
        if (idx > 5) fill = 1;
        if (railFill) setv(railFill, '--rail', fill.toFixed(3));
      }
      return idx;
    };

    const armed = root.classList.contains('sx-armed');
    const view = root.querySelector('.sx-world__view');
    const canvas = root.querySelector('[data-sx-world]');
    let world = null;
    if (armed && view) {
      try { world = canvas ? new World(canvas) : null; } catch (e) { world = null; }
      if (world) { root.classList.add('sx-coded'); const hv = root.querySelector('.sx-hud__view'); if (hv) { const fc = document.createElement('canvas'); fc.className = 'sx-fx'; fc.setAttribute('aria-hidden', 'true'); hv.prepend(fc); world.attachVeil(fc); } }
    }
    if (!world) {
      root.classList.remove('sx-armed');
      let raf = 0;
      addEventListener('resize', setTop, { passive: true, signal });
      addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => track(innerHeight)); }, { passive: true, signal });
      track(innerHeight);
      return;
    }

    /* ----- Live mode ----- */
    const gate = root.querySelector('.sx-gate');
    const portal = root.querySelector('.sx-portal__view');
    const rims = [...root.querySelectorAll('[data-sx-rim]')];
    const rimSvg = root.querySelector('.sx-portal__rim');
    const formula = root.querySelector('.sx-formula');
    const tabs = [...root.querySelectorAll('[data-sx-tab]')];
    const doseOut = root.querySelector('[data-sx-dose]');
    const depthOut = root.querySelector('[data-sx-depth]');
    const capOut = root.querySelector('[data-sx-cap]');
    const sigOut = root.querySelector('[data-sx-sig]');
    const drifts = [...root.querySelectorAll('[data-sx-drift]')];
    const relicWrap = root.querySelector('[data-sx-relic]');
    const relicSection = root.querySelector('.sx-relic');
    const mainForm = root.querySelector('[data-lp-main-buy]');
    const flavorOut = root.querySelector('[data-sx-flavor]');
    const bloodBar = root.querySelector('[data-sx-blood]');
    const bloodOut = root.querySelector('[data-sx-blood-v]');
    const area = root.querySelector('[data-sx-area]');
    const boss = root.querySelector('[data-sx-boss]');
    const legend = root.querySelector('.sx-legend');
    const toast = root.querySelector('[data-sx-toast]');
    const glitch = root.querySelector('[data-sx-glitch]');
    const relicsOut = root.querySelector('[data-sx-relics]');
    const pBlood = root.querySelector('.sx-portal__blood');
    const dropsLayer = root.querySelector('[data-sx-drops]');
    const seenArea = new Set();
    const pulse = (el, cls = 'is-on') => { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };
    const K = 4.0;
    const cam = { z: 0, look: [0, 0] };
    const S = { vw: innerWidth, vh: innerHeight, top: 0, h: 1, gTop: 0, gH: 1, fTop: 0, fH: 1, visible: true, relicVisible: false, zT: 0, lookT: [0, 0], vel: 0, intro: -1, frontIdx: -1, t0: 0 };
    let flavorAccent = [0.9, 0.1, 0.1];

    const measure = () => {
      setTop();
      S.vw = innerWidth; S.vh = innerHeight; S.dRest = 0;
      const sy = scrollY;
      S.top = root.getBoundingClientRect().top + sy; S.h = root.offsetHeight;
      if (gate) { S.gTop = gate.getBoundingClientRect().top + sy; S.gH = gate.offsetHeight; }
      if (formula) { S.fTop = formula.getBoundingClientRect().top + sy; S.fH = formula.offsetHeight; }
      world.size(view.clientWidth, view.clientHeight);
      if (rimSvg) rimSvg.setAttribute('viewBox', `0 0 ${S.vw} ${gate ? gate.querySelector('.sx-gate__stage').clientHeight : S.vh}`);
      if (relic) relic.size();
    };
    addEventListener('sx:lite', () => { if (relic) relic.size(); }, { signal });

    /* Flavor palette: the nave takes the colour of the chosen flavor. */
    const flavorPalette = () => {
      const p = clone(PAL.blood);
      p.accent = flavorAccent.slice(); p.acc = 1.15;
      p.ember = p.ember.map((c, i) => mix(c, flavorAccent[i], 0.45));
      p.fog = p.fog.map((c, i) => mix(c, flavorAccent[i] * 0.3, 0.3));
      return p;
    };

    /* Relic */
    let relic = null;
    const figs = relicWrap ? [...relicWrap.querySelectorAll('.sx-tub')] : [];
    const currentFig = () => figs.find(f => !f.hidden) || figs[0];
    const accentNow = fig => { const r = mainForm && mainForm.querySelector('input[name="id"]:checked'); return hex(toneOf(r && r.dataset.title) || fig.dataset.sxAccent); };
    const syncFlavor = () => {
      const fig = currentFig();
      if (!fig) return;
      const radio = mainForm && mainForm.querySelector('input[name="id"]:checked');
      flavorAccent = hex(toneOf(radio && radio.dataset.title) || fig.dataset.sxAccent);
      if (flavorOut && radio) decode(flavorOut, radio.dataset.title || flavorOut.textContent);
      if (active === 1) world.palette(flavorPalette(), S.flavorFrom);
      if (relic && fig.dataset.sxTex) relic.show(fig.dataset.sxTex, flavorAccent).then(() => relicSection && relicSection.classList.add('is-gl')).catch(() => {});
    };
    if (relicWrap && root.dataset.sxTurn !== 'false') {
      try {
        relic = new Relic(relicWrap.querySelector('.sx-altar__gl'));
        const fig = currentFig();
        if (fig) { flavorAccent = accentNow(fig); relic.show(fig.dataset.sxTex, flavorAccent).then(() => { relicSection.classList.add('is-gl'); relic.size(); }).catch(() => { relic = null; }); }
      } catch (e) { relic = null; }
    } else if (figs.length) flavorAccent = accentNow(currentFig());
    if (mainForm) mainForm.addEventListener('change', e => { if (e.target.name === 'id') { const r = (e.target.closest('label') || e.target).getBoundingClientRect(); S.flavorFrom = { x: r.left + r.width / 2, y: r.top + r.height / 2 }; setTimeout(syncFlavor, 0); } }, { signal });
    if (PREVIEW && mainForm) {
      previewChip();
      mainForm.addEventListener('click', e => {
        const lab = e.target.closest('.sx-flavor'); if (!lab) return;
        const inp = lab.querySelector('input[name="id"]'); if (!inp) return;
        const r = lab.getBoundingClientRect(); S.flavorFrom = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
        mainForm.querySelectorAll('.sx-flavor.is-preview').forEach(x => x.classList.remove('is-preview'));
        const fig = figs.find(f => f.dataset.lpScene === inp.value);
        if (inp.disabled) {
          e.preventDefault(); lab.classList.add('is-preview');
          if (!fig) return;
          figs.forEach(f => { f.hidden = f !== fig; });
          flavorAccent = hex(toneOf(inp.dataset.title) || fig.dataset.sxAccent);
          if (flavorOut) decode(flavorOut, inp.dataset.title || flavorOut.textContent);
          if (active === 1) world.palette(flavorPalette(), S.flavorFrom);
          if (relic && fig.dataset.sxTex) relic.show(fig.dataset.sxTex, flavorAccent).then(() => relicSection && relicSection.classList.add('is-gl')).catch(() => {});
        } else if (inp.checked) { if (fig) figs.forEach(f => { f.hidden = f !== fig; }); syncFlavor(); }
      }, { signal });
    }

    /* Pointer look + magnets */
    addEventListener('pointermove', e => {
      if (!fine.matches) return;
      S.lookT[0] = (e.clientX / S.vw - 0.5) * 1.2;
      S.lookT[1] = -(e.clientY / S.vh - 0.5) * 0.8;
    }, { passive: true, signal });
    if (fine.matches) root.querySelectorAll('[data-sx-magnet]').forEach(el => {
      el.addEventListener('pointermove', e => { const r = el.getBoundingClientRect(); el.style.translate = `${((e.clientX - r.left) / r.width - 0.5) * 14}px ${((e.clientY - r.top) / r.height - 0.5) * 10}px`; }, { signal });
      el.addEventListener('pointerleave', () => { el.style.translate = ''; }, { signal });
    });
    root.querySelectorAll('[data-sx-exhibit]').forEach(ex => {
      const img = ex.querySelector('[data-sx-float] img');
      if (!img || !fine.matches) return;
      ex.addEventListener('pointermove', e => { const r = ex.getBoundingClientRect(); img.style.transform = `perspective(900px) rotateY(${((e.clientX - r.left) / r.width - 0.5) * 16}deg) rotateX(${-((e.clientY - r.top) / r.height - 0.5) * 8}deg)`; }, { signal });
      ex.addEventListener('pointerleave', () => { img.style.transform = ''; }, { signal });
    });

    /* Loot: every successful add becomes a relic drop */
    const owned = new Set();
    const drop = (keys, name) => {
      keys.forEach(k => owned.add(k));
      if (relicsOut) relicsOut.textContent = String(Math.min(3, owned.size));
      if (toast) { toast.querySelector('[data-sx-toast-t]').textContent = name; pulse(toast); }
      pulse(glitch); world.flash = 0.3;
    };
    const titleOf = el => (el && el.textContent || '').trim();
    const lootMo = new MutationObserver(list => list.forEach(m => {
      const btn = m.target;
      if (!btn.classList.contains('is-added') || String(m.oldValue || '').includes('is-added')) return;
      if (btn.hasAttribute('data-lp-bundle-add')) drop(['relic', 'tee', 'shaker'], 'Full set · 3/3');
      else {
        const ex = btn.closest('.sx-exhibit');
        if (ex) drop([ex.classList.contains('sx-exhibit--tee') ? 'tee' : 'shaker'], titleOf(ex.querySelector('.sx-exhibit__product')));
        else drop(['relic'], titleOf(root.querySelector('.sx-console__title')) + (flavorOut ? ' · ' + (flavorOut.dataset.sxText || flavorOut.textContent) : ''));
      }
    }));
    root.querySelectorAll('[data-lp-add], [data-lp-bundle-add], [data-lp-sticky-add]').forEach(b => lootMo.observe(b, { attributes: true, attributeFilter: ['class'], attributeOldValue: true }));
    signal.addEventListener('abort', () => lootMo.disconnect());

    /* Decode marks as they arrive */
    const decoders = [...root.querySelectorAll('[data-sx-decode]')];
    const glitchers = [...root.querySelectorAll('.sx-h2 .sx-chrome, .sx-console__title .sx-chrome, .sx-vault__title .sx-chrome, .sx-finale__title .sx-chrome')];
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (!en.isIntersecting) return;
      if (en.target.hasAttribute('data-sx-decode')) decode(en.target);
      else { en.target.classList.remove('sx-glitch'); void en.target.offsetWidth; en.target.classList.add('sx-glitch'); }
      io.unobserve(en.target);
    }), { threshold: 0.6 });
    decoders.forEach(d => io.observe(d)); glitchers.forEach(g => io.observe(g));

    /* Only render while the section is on screen */
    const vis = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.target === root) { S.visible = en.isIntersecting; if (S.visible) start(); }
      else S.relicVisible = en.isIntersecting;
    }), { rootMargin: '10% 0px' });
    vis.observe(root);
    if (relicWrap) vis.observe(relicWrap);

    let resizeT = 0;
    addEventListener('resize', () => { clearTimeout(resizeT); resizeT = setTimeout(measure, 120); }, { passive: true, signal });
    if ('ResizeObserver' in window) { const ro = new ResizeObserver(() => { clearTimeout(resizeT); resizeT = setTimeout(measure, 120); }); ro.observe(root); signal.addEventListener('abort', () => ro.disconnect()); }

    /* Entry: the portal glides in once the loader opens */
    const entryOpen = () => document.documentElement.classList.contains('nf-entry-open') && !document.querySelector('.nf-entry.is-leaving, [data-nf-entry].is-leaving');
    const armIntro = () => { if (S.intro < 0 && !entryOpen()) S.intro = performance.now(); };
    armIntro();
    if (S.intro < 0) { const mo = new MutationObserver(() => { armIntro(); if (S.intro >= 0) mo.disconnect(); }); mo.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] }); setTimeout(() => { if (S.intro < 0) S.intro = performance.now(); }, 7000); }

    const PW = 0.8, PS = 1.25;
    const archPath = (bx, by, s) => {
      const w = PW * s, sy = by - PS * s, ay = sy - PW * Math.sqrt(3) * s, r = 2 * w;
      return `M${(bx - w).toFixed(1)} ${by.toFixed(1)}L${(bx - w).toFixed(1)} ${sy.toFixed(1)}A${r.toFixed(1)} ${r.toFixed(1)} 0 0 1 ${bx.toFixed(1)} ${ay.toFixed(1)}A${r.toFixed(1)} ${r.toFixed(1)} 0 0 1 ${(bx + w).toFixed(1)} ${sy.toFixed(1)}L${(bx + w).toFixed(1)} ${by.toFixed(1)}Z`;
    };

    /* Bleeding: drops gather at the drip tips of every blood image, fall, and ring the flooded floor */
    const tipsOf = img => {
      try {
        const w = 240, h = Math.max(8, Math.round(w * img.naturalHeight / Math.max(1, img.naturalWidth)));
        const c = document.createElement('canvas'); c.width = w; c.height = h;
        const x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, w, h);
        const d = x.getImageData(0, 0, w, h).data, bot = new Int16Array(w).fill(-1);
        for (let i = 0; i < w; i++) for (let j = h - 1; j >= 0; j--) if (d[(j * w + i) * 4 + 3] > 110) { bot[i] = j; break; }
        const out = [];
        for (let i = 3; i < w - 3; i++) {
          const b = bot[i]; if (b < h * 0.2) continue;
          let top = true; for (let k = -3; k <= 3; k++) if (bot[i + k] > b) top = false;
          if (top && !out.some(o => Math.abs(o[0] - i / w) < 0.035)) out.push([i / w, (b + 1) / h]);
        }
        return out.sort((a, b) => b[1] - a[1]).slice(0, 8);
      } catch (e) { return []; }
    };
    const bleeders = [...root.querySelectorAll('[data-sx-bleed]')].map(img => ({ img, kind: img.dataset.sxBleed, tips: null, t: 0.8 + Math.random() * 1.5 }));
    const drops = [];
    const landing = (vx, vy, zPref, vw2, hh) => {
      /* the floor under a screen point: prefer zPref, come closer if the floor there is above the drop */
      const ry = 1.06 + cam.look[1] * 0.1;
      let z = zPref, k = FL / z, fy = hh + (ry * k + PITCH) * hh;
      if (fy < vy + 50) { k = Math.max(0.05, ((vy + 50) / hh - 1 - PITCH) / ry); z = Math.max(0.7, FL / k); fy = hh + (ry * (FL / z) + PITCH) * hh; }
      return { x: (vx - vw2) / ((FL / z) * hh) + cam.look[0] * 0.2, z: cam.z + z, y: fy };
    };
    const bleed = (dt, idx, vr) => {
      if (!dropsLayer || !view) return;
      const vw2 = vr.width / 2, hh = vr.height / 2;
      bleeders.forEach(b => {
        if (!b.img.complete || !b.img.naturalWidth) return;
        const live = b.kind === 'finale' ? idx === 7 : idx === 0 && (S.gp || 0) < (b.kind === 'portal' ? 0.34 : 0.22) && (S.it || 0) > 0.95 && (b.kind !== 'portal' || S.poured);
        if (!live) return;
        b.t -= dt;
        if (b.t > 0 || drops.length > 5) return;
        b.t = (b.kind === 'finale' ? 0.9 : b.kind === 'portal' ? 1.8 : 1.2) + Math.random() * 1.8;
        if (!b.tips) b.tips = tipsOf(b.img);
        if (!b.tips.length) return;
        const r = b.img.getBoundingClientRect();
        if (r.width < 20 || r.bottom < vr.top || r.top > vr.bottom) return;
        const tip = b.tips[(Math.random() * b.tips.length) | 0];
        const vx = r.left + tip[0] * r.width - vr.left, vy = r.top + tip[1] * r.height - vr.top;
        const zPref = b.kind === 'finale' ? 3.4 : (S.pd || 4.9) * (b.kind === 'portal' ? 0.97 : 0.86);
        const L = landing(vx, vy, zPref, vw2, hh);
        const el = document.createElement('i'); el.className = 'sx-drop';
        dropsLayer.appendChild(el);
        drops.push({ el, x: vx, y: vy, v: 0, age: 0, L, s: 0.55 + Math.random() * 0.6 });
      });
      for (let i = drops.length - 1; i >= 0; i--) {
        const d = drops[i];
        d.age += dt;
        const grow = Math.min(1, d.age / 0.45);
        if (d.age > 0.45) { d.v += 2600 * dt; d.y += d.v * dt; }
        const st = 1 + Math.min(0.9, d.v / 2400);
        d.el.style.transform = `translate3d(${d.x.toFixed(1)}px,${d.y.toFixed(1)}px,0) scale(${(d.s * (0.4 + 0.6 * grow) / Math.sqrt(st)).toFixed(3)},${(d.s * (0.4 + 0.6 * grow) * st).toFixed(3)})`;
        if (d.y >= d.L.y || d.age > 4) {
          if (d.y >= d.L.y) world.ripple(d.L.x, d.L.z, 0.8 + d.s * 0.5, d.x, d.L.y);
          d.el.remove(); drops.splice(i, 1);
        }
      }
    };

    let raf = 0, last = 0, acc = 0, frames = 0, sigT = 0;
    const seenCh = new Set();
    const tick = now => {
      raf = 0;
      if (!S.visible || document.hidden) { last = 0; return; }
      raf = requestAnimationFrame(tick);
      /* lite: the whole hall (world, slabs, relic) runs at half rate; the page itself still scrolls at full rate */
      if (world.half && (S.hf = !S.hf)) return;
      const dt = last ? Math.min(0.07, (now - last) / 1000) : 1 / 60; last = now;
      const sy = scrollY, vh = S.vh, vw = S.vw;
      const rel = sy - S.top;

      /* camera */
      S.zT = Math.max(0, rel) / vh * K;
      const zPrev = cam.z;
      cam.z += (S.zT - cam.z) * (1 - Math.exp(-dt * 7));
      S.vel += (Math.min(1, Math.abs(cam.z - zPrev) / dt * 0.12) - S.vel) * (1 - Math.exp(-dt * 5));
      /* touch screens sway slowly on their own; lite holds the gaze still so a resting hall can skip frames */
      if (!fine.matches) { if (world.lite) { S.lookT[0] = 0; S.lookT[1] = 0; } else { const t = now / 1000; S.lookT[0] = Math.sin(t * 0.17) * 0.35; S.lookT[1] = Math.cos(t * 0.13) * 0.12; } }
      cam.look[0] += (S.lookT[0] - cam.look[0]) * (1 - Math.exp(-dt * 2.2));
      cam.look[1] += (S.lookT[1] - cam.look[1]) * (1 - Math.exp(-dt * 2.2));
      world.z = cam.z; world.look = cam.look; world.vel = S.vel; world.time += dt;
      world.flash *= Math.exp(-dt * 3.5);

      /* chapter + palette */
      /* read phase: every rect this frame needs, before any style is written (no forced layouts) */
      const R = { vr: view.getBoundingClientRect(), root: root.getBoundingClientRect(), ch: chapters.map(c => c.getBoundingClientRect().top), dr: drifts.map(el => el.getBoundingClientRect()), lg: legend ? legend.getBoundingClientRect() : null, rl: relicWrap && S.relicVisible ? relicWrap.getBoundingClientRect() : null, stageH: gate ? gate.firstElementChild.clientHeight : 0 };
      const idx = track(vh, R);
      if (idx !== active) {
        active = idx;
        root.dataset.sxAt = idx;
        const ch = chapters.find(c => +c.dataset.sxCh === idx);
        const pal = ch ? ch.dataset.sxPal : 'blood';
        world.door = idx === 2 || idx === 4 || idx === 6 ? 0.3 : 1;
        /* each chapter shows its embers once per visit; coming back to it only relights the hall */
        world.palette(pal === 'flavor' ? flavorPalette() : pal, null, seenCh.has(idx) ? FX_QUIET : FX_LEE_FIRST); seenCh.add(idx);
        if (capOut) decode(capOut, CAPS[idx] || CAPS[0]);
        if (idx === 7) { const fin = root.querySelector('.sx-finale'); if (fin) fin.classList.add('is-risen'); }
        if (area && AREAS[idx] && !seenArea.has(idx)) {
          seenArea.add(idx);
          area.querySelector('[data-sx-area-k]').textContent = AREAS[idx][0];
          area.querySelector('[data-sx-area-s]').textContent = AREAS[idx][2];
          decode(area.querySelector('[data-sx-area-t]'), AREAS[idx][1]);
          pulse(area);
        }
      }
      world.step(dt);

      /* 0: portal */
      if (gate && portal) {
        const gp = clamp((sy - S.gTop) / Math.max(1, S.gH - vh), 0, 1);
        setv(gate, '--gp', gp.toFixed(3));
        const it = S.intro < 0 ? 0 : smooth(0, 2400, now - S.intro);
        if (!S.dRest && gp < 0.02) {
          /* rest distance: the largest door that fits between the bleeding title and the copy below it */
          const st = gate.firstElementChild.getBoundingClientRect(), tt = root.querySelector('.sx-gate__title'), ft = root.querySelector('.sx-gate__foot');
          const lim = tt ? tt.getBoundingClientRect().bottom - st.top + 14 : 0, low = ft ? ft.getBoundingClientRect().top - st.top - 24 : st.height;
          const c0 = { z: cam.z, look: [0, 0] }, h0 = gate.firstElementChild.clientHeight;
          /* short phones (SE, small Androids) get a smaller, farther door so the line below never sits on it */
          let best = 8.4;
          for (let t = 3.5; t <= 8.4; t += 0.05) { const Q = project(0, -1, c0.z + t, c0, vw, h0); if (Q && Q.y - Q.s * 2.64 >= lim && Q.y <= low) { best = t; break; } }
          S.dRest = best;
        }
        const d = ((S.dRest || 4.9) + (1 - it) * 5) / (1 + gp * gp * 25);
        S.pd = d;
        const stageH = R.stageH;
        /* touch screens: the portal ignores the idle sway, so its clip path only changes while you scroll */
        const P = project(0, -1, cam.z + d, fine.matches ? cam : { z: cam.z, look: [0, 0] }, vw, stageH);
        if (P && gp < 0.999) {
          const path = archPath(P.x, P.y, P.s);
          if (path !== S.lastPath) { S.lastPath = path; portal.style.clipPath = `path('${path}')`; rims.forEach(r => r.setAttribute('d', path)); }
          if (pBlood) { const k = P.s / 200; setv(pBlood, 'transform', `translate3d(${(P.x - 180 * k).toFixed(1)}px,${(P.y - 560 * k).toFixed(1)}px,0) scale(${k.toFixed(4)})`); setv(pBlood, 'opacity', (1 - smooth(0.28, 0.6, gp)).toFixed(2)); }
        } else if (S.lastPath !== 'none') { S.lastPath = 'none'; portal.style.clipPath = 'none'; rims.forEach(r => r.setAttribute('d', '')); if (pBlood) setv(pBlood, 'opacity', '0'); }
        if (S.intro >= 0 && !S.poured) { S.poured = true; gate.classList.add('is-pour'); }
        S.gp = gp; S.it = it;
        world.port = [cam.z + d, PW, (0.55 + 0.25 * Math.sin(now / 900)) * (1 - gp) * it];
      }

      /* II: the procession */
      if (formula && tabs.length) {
        const mob = mobileQ.matches, tab = vw < 990;
        const camStart = Math.max(0, S.fTop - S.top) / vh * K;
        const range = Math.max(0.1, S.fH - vh) / vh * K;
        const FRONT = mob ? 2.6 : 2.3, n = tabs.length;
        let best = -1, bestD = 1e9;
        tabs.forEach((el, i) => {
          const zi = camStart + FRONT + range * (0.1 + 0.78 * (n > 1 ? i / (n - 1) : 0));
          const x = mob ? (i % 2 ? 0.1 : -0.1) : tab ? (i % 2 ? 0.2 : -0.2) : 0.6 + (i % 2 ? 0.34 : -0.14);
          const y = mob ? -0.28 : tab ? -0.25 : 0.0;
          const P = project(x, y, zi, cam, vw, vh);
          /* Phones: a slab dissolves before it grows past the screen, so the one you read is always whole and opaque. */
          const near = mob ? 1.55 : 1.05;
          if (!P || P.d < near) { setv(el, 'opacity', '0'); setv(el, 'visibility', 'hidden'); return; }
          const sc = P.s * 0.99 / 300 * (mob ? 0.8 : 1);
          setv(el, 'visibility', '');
          setv(el, 'transform', `translate3d(${(P.x - 150 * sc).toFixed(1)}px,${(P.y - 220 * sc).toFixed(1)}px,0) scale(${sc.toFixed(4)})`);
          setv(el, 'opacity', ((mob ? smooth(1.55, 1.95, P.d) : smooth(1.05, 1.5, P.d)) * (1 - smooth(10, 15, P.d))).toFixed(2));
          setv(el, 'zIndex', String(1000 - Math.round(P.d * 20)));
          const dd = Math.abs(P.d - FRONT);
          if (P.d > (mob ? 1.9 : 1.45) && dd < bestD) { bestD = dd; best = i; }
        });
        if (best !== S.frontIdx) {
          if (S.frontIdx >= 0 && tabs[S.frontIdx]) tabs[S.frontIdx].classList.remove('is-front');
          if (best >= 0) { tabs[best].classList.add('is-front'); if (doseOut) doseOut.textContent = String(best + 1).padStart(2, '0'); }
          S.frontIdx = best;
        }
      }

      /* drift of giant words */
      drifts.forEach((el, i) => { const r = R.dr[i]; if (r.bottom > -200 && r.top < vh + 200) setv(el, '--drift', ((r.top + r.height / 2 - vh / 2) * 0.22).toFixed(0) + 'px'); });

      /* HUD */
      if (depthOut) sett(depthOut, (cam.z * 10).toFixed(1).padStart(5, '0'));
      const prog = clamp(rel / Math.max(1, S.h - vh), 0, 1);
      if (bloodBar) setv(bloodBar, '--blood', prog.toFixed(3));
      if (bloodOut) sett(bloodOut, String(Math.round(prog * 100)).padStart(3, '0'));
      if (boss && legend && idx === 3) {
        const lr = R.lg;
        const lp = clamp((vh * 0.55 - lr.top) / Math.max(1, lr.height), 0, 1);
        const hit = Math.floor(lp * 5);
        if (hit !== S.bossHit) { if (S.bossHit != null && hit > S.bossHit) { S.bossHp = 0.62 + Math.random() * 0.12; pulse(boss, 'is-hit'); world.flash = Math.max(world.flash, 0.22); } S.bossHit = hit; }
        S.bossHp = Math.min(1, (S.bossHp == null ? 1 : S.bossHp) + dt * 0.28);
        S.chip = S.chip == null || S.chip < S.bossHp ? S.bossHp : S.chip - Math.min(S.chip - S.bossHp, dt * 0.5);
        setv(boss, '--boss', S.bossHp.toFixed(3));
        setv(boss, '--chip', S.chip.toFixed(3));
      }
      sigT += dt;
      if (sigOut && sigT > 1.3) { sigT = 0; const n = 3 + ((Math.random() * 3) | 0); sigOut.textContent = '▮'.repeat(n) + '▯'.repeat(5 - n); }

      /* relic */
      if (relic && S.relicVisible) {
        const t = now / 1000;
        const r = R.rl;
        const target = Math.sin(t * 0.45) * 0.2 + cam.look[0] * 0.35 + clamp((r.top + r.height / 2 - vh / 2) / vh, -1, 1) * 0.45;
        relic.phi += (target - relic.phi) * (1 - Math.exp(-dt * 3));
        relic.draw(dt);
      }

      bleed(dt, idx, R.vr);
      world.vr = R.vr;
      world.draw();

    };
    const start = () => { if (!raf) { last = 0; raf = requestAnimationFrame(tick); } };
    document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); }, { signal });

    root._sx = { world, cam, S };
    measure();
    requestAnimationFrame(() => { root.classList.add('sx-live'); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    addEventListener('load', measure, { once: true, signal });
    start();

    document.addEventListener('shopify:section:unload', e => { if (!e.target.contains(root)) return; abort.abort(); io.disconnect(); vis.disconnect(); cancelAnimationFrame(raf); }, { signal });
  });

  /* ---------- Product pages: the same nave behind the relic ---------- */
  let loot = null;
  const hookCart = () => {
    if (window.__sxCartHook) return;
    window.__sxCartHook = true;
    const hit = () => { if (loot) loot(); };
    const isAdd = u => /\/cart\/add/.test(String(u || ''));
    if (window.fetch) {
      const f = window.fetch;
      window.fetch = function (input, opts) {
        const p = f.apply(this, arguments);
        try { if (isAdd(typeof input === 'string' ? input : input && input.url)) p.then(r => { if (r && r.ok) hit(); }, () => {}); } catch (e) {}
        return p;
      };
    }
    const XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__sxAdd = isAdd(u); return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () { if (this.__sxAdd) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) hit(); }); return XS.apply(this, arguments); };
  };
  const initPdp = () => document.querySelectorAll('[data-sx-pdp]').forEach(el => {
    if (el.dataset.sxReady) return;
    el.dataset.sxReady = '1';
    const hud = el.querySelector('.sxp__hud') || el;
    if (el.parentElement !== document.body) document.body.prepend(el);
    if (hud !== el) document.body.appendChild(hud);
    document.documentElement.classList.add('sx-pdp-on');
    const setTop = () => document.documentElement.style.setProperty('--sx-top', headerBottom() + 'px');
    setTop();
    /* Loot card: tier + stats above the product title */
    const titleRow = document.querySelector('#content.nf-rp .product-detail .title-row') || document.querySelector('#content.nf-rp .product-detail .title');
    if (titleRow && !document.querySelector('.sxp-loot')) {
      const box = document.createElement('div');
      box.className = 'sxp-loot sxp-loot--' + String(el.dataset.sxTier || '').toLowerCase();
      box.setAttribute('aria-hidden', 'true');
      const stats = String(el.dataset.sxStats || '').split(';').filter(Boolean).map(r => { const [k, v] = r.split('|'); return `<li><span>${k}</span><b>${v || ''}</b></li>`; }).join('');
      box.innerHTML = `<p class="sxp-tier"><b>${el.dataset.sxTier || ''}</b><span>${el.dataset.sxSub || ''}</span></p>` + (stats ? `<ul class="sxp-stats">${stats}</ul>` : '');
      titleRow.parentNode.insertBefore(box, titleRow);
    }
    /* the CTA drips read the uncropped blood edge */
    const edge = el.dataset.sxEdge || String(el.dataset.sxSpill || '').replace('nf-bl-spill.webp', 'nf-blood-edge.webp').replace(/\?v=\d+/, '');
    if (edge) document.documentElement.style.setProperty('--sxp-edge', `url("${edge}")`);
    if (el.dataset.sxSpill) document.documentElement.style.setProperty('--sxp-spill', `url("${el.dataset.sxSpill}")`);
    /* Gallery: cut-out relics stand on the flooded floor of the nave, documents stay whole, scenes stay photographs */
    const gal = document.querySelector('#content.nf-rp .product-detail .gallery .main-image');
    if (gal) {
      gal.classList.add('sxp-altarbox');
      const thumbArch = () => document.querySelectorAll('#content.nf-rp .product-detail .gallery .thumbnail .thumbnail__media').forEach(m => archFrame(m, m.querySelector('.inline-image') || m.firstElementChild, { pad: 3, gap: 3, tick: 2, bottom: 3, cls: 'sxa--thumb' }));
      thumbArch(); setTimeout(thumbArch, 1500);
      const probe = (img, slide) => {
        const u = img.getAttribute('src') || img.currentSrc || '';
        if (!u) { slide.classList.add('sxp-scene'); return; }
        if (/supplement|facts|nutrition|label/i.test(u)) { slide.classList.add('sxp-doc'); return; }
        const t = new Image();
        t.crossOrigin = 'anonymous';
        t.onload = () => {
          let cut = false, box = null;
          try {
            const W = 64, H = Math.max(16, Math.round(64 * t.naturalHeight / t.naturalWidth));
            const c = document.createElement('canvas'); c.width = W; c.height = H;
            const x = c.getContext('2d'); x.drawImage(t, 0, 0, W, H);
            const d = x.getImageData(0, 0, W, H).data;
            const a = (i, j) => d[(j * W + i) * 4 + 3];
            cut = a(0, 0) + a(W - 1, 0) + a(0, H - 1) + a(W - 1, H - 1) < 40;
            if (cut) {
              let x0 = W, y0 = H, x1 = -1, y1 = -1;
              for (let j = 0; j < H; j++) for (let i = 0; i < W; i++) if (a(i, j) > 28) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (j < y0) y0 = j; if (j > y1) y1 = j; }
              if (x1 > x0 && y1 > y0) box = [x0 / W, y0 / H, (x1 + 1) / W, (y1 + 1) / H];
            }
          } catch (e) {}
          /* centre the relic on its true silhouette, not on the canvas it was exported in */
          if (box) {
            /* centred on its true silhouette, feet on the waterline (82% down), reflection starting at the feet */
            const bw = box[2] - box[0], bh = box[3] - box[1], bx = (box[0] + box[2]) / 2;
            const s = Math.min(0.62 / bh, 0.7 / bw, 1.25);
            slide.style.setProperty('--s', s.toFixed(3));
            slide.style.setProperty('--tx', (-(bx - 0.5) * s * 100).toFixed(2) + '%');
            slide.style.setProperty('--ty', ((0.32 - (box[3] - 0.5) * s) * 100).toFixed(2) + '%');
            const im = img;
            const gap = () => { const h = im.offsetHeight; if (h) slide.style.setProperty('--rgp', (-(1 - box[3]) * h).toFixed(1) + 'px'); };
            gap(); if ('ResizeObserver' in window) new ResizeObserver(gap).observe(im);
          }
          slide.classList.add(cut ? 'sxp-cut' : 'sxp-scene');
        };
        t.onerror = () => slide.classList.add('sxp-scene');
        t.src = u.replace(/([?&])width=\d+/, '$1width=120');
      };
      gal.querySelectorAll('.slide').forEach(s => {
        if (/sxp-(cut|doc|scene)/.test(s.className)) return;
        const img = s.querySelector('.product-media--image img');
        if (img) probe(img, s); else s.classList.add('sxp-scene');
      });
      /* the viewer opens onto the nave: the page steps back, the hall stays lit behind the photograph */
      const fileOf = u => String(u || '').split('?')[0].split('/').pop();
      new MutationObserver(() => {
        const gv = document.querySelector('body > .gallery-viewer');
        if (document.documentElement.classList.contains('sxp-viewing') !== !!gv) { document.documentElement.classList.toggle('sxp-viewing', !!gv); document.dispatchEvent(new Event('sxp:view')); }
        if (!gv || gv._sx) return;
        gv._sx = 1;
        const zi = gv.querySelector('.gallery-viewer__zoom-image');
        if (!zi) return;
        const mark = () => {
          const f = fileOf(zi.getAttribute('src'));
          const sl = [...gal.querySelectorAll('.slide')].find(x => { const l = x.querySelector('a.show-gallery'); return l && fileOf(l.getAttribute('href')) === f; });
          zi.classList.toggle('sxp-zcut', !!sl && sl.classList.contains('sxp-cut'));
        };
        mark(); new MutationObserver(mark).observe(zi, { attributes: true, attributeFilter: ['src'] });
      }).observe(document.body, { childList: true });
    }
    /* Flavour and colour sigils: each option carries its own relic and its own light */
    const sels = [...document.querySelectorAll('#content.nf-rp .product-detail .option-selector')];
    const handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
    if (handle && sels.some(s => s.classList.contains('option-selector--swatch'))) {
      let flav = {};
      try { flav = JSON.parse(el.dataset.sxFlavors || '{}'); } catch (e) {}
      const ART = { 'prodigy pop': 1, 'sour watermelon': 1 };
      fetch('/products/' + handle + '.js').then(r => r.json()).then(p => {
        sels.forEach((sel, idx) => {
          if (!sel.classList.contains('option-selector--swatch')) return;
          sel.classList.add('sxp-sigils');
          sel.querySelectorAll('.opt-label').forEach(lab => {
            const inp = document.getElementById(lab.htmlFor);
            const val = inp ? inp.value : lab.textContent.trim();
            const v = p.variants.find(x => x.options[idx] === val && x.featured_image);
            let src = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
            if (src) src += (src.includes('?') ? '&' : '?') + 'width=220';
            lab.style.setProperty('--fl', flav[val.toLowerCase()] || '#e8e2da');
            /* flavours with their own art rise out of the plate instead of showing the tub */
            const fk = val.toLowerCase().trim();
            const art = ART[fk] && el.dataset.sxSpill ? String(el.dataset.sxSpill).replace(/nf-bl-spill\.webp(\?v=\d+)?/, 'nf-flavor-' + fk.replace(/[^a-z0-9]+/g, '-') + '.webp') : '';
            if ((src || art) && !lab.querySelector('.sxp-sigil__img')) {
              const w = document.createElement('span'); w.className = 'sxp-sigil__img'; w.setAttribute('aria-hidden', 'true');
              const im = document.createElement('img'); im.alt = ''; im.decoding = 'async';
              if (art) { lab.classList.add('sxp-art'); im.onerror = () => { im.onerror = null; lab.classList.remove('sxp-art'); if (src) im.src = src; }; im.src = art; } else im.src = src;
              w.appendChild(im); lab.prepend(w);
            }
            if (!lab.querySelector('.sxp-sigil__state')) { const s = document.createElement('span'); s.className = 'sxp-sigil__state'; s.setAttribute('aria-hidden', 'true'); lab.appendChild(s); }
          });
        });
      }).catch(() => {});
    }
    /* the edition photo hangs in a horseshoe window with its alfiz */
    const edm = document.querySelector('#content.nf-rp .nf-edition__media');
    if (edm) archFrame(edm, edm.querySelector('img'), { pad: 16, gap: 8, tick: 7, alfiz: true, bottom: 16, cls: 'sxa--edition' });
    /* Product cards shot on white: the white is lifted off in a worker (shadows kept), so the tub sits on the nave */
    const CARD_IMG = '#content.nf-rp .product-block .product-block__image img, #content.nf-rp .product-block .image-label-wrap__images img';
    if ('OffscreenCanvas' in window && 'Worker' in window && 'IntersectionObserver' in window) {
      const src = `self.onmessage=async e=>{const{id,url}=e.data;try{const bm=await createImageBitmap(await (await fetch(url)).blob());const w=Math.min(640,bm.width),h=Math.round(w*bm.height/bm.width);const c=new OffscreenCanvas(w,h),x=c.getContext('2d',{willReadFrequently:true});x.drawImage(bm,0,0,w,h);const im=x.getImageData(0,0,w,h),d=im.data,n=w*h,bg=new Uint8Array(n),q=new Int32Array(n);let qh=0,qt=0;const ok=i=>{const r=d[i*4],g=d[i*4+1],b=d[i*4+2],mx=Math.max(r,g,b),mn=Math.min(r,g,b);return d[i*4+3]>200&&mn>196&&mx-mn<24};const push=i=>{if(!bg[i]&&ok(i)){bg[i]=1;q[qt++]=i}};for(let X=0;X<w;X++){push(X);push((h-1)*w+X)}for(let Y=0;Y<h;Y++){push(Y*w);push(Y*w+w-1)}while(qh<qt){const i=q[qh++],X=i%w;if(X>0)push(i-1);if(X<w-1)push(i+1);if(i>=w)push(i-w);if(i<n-w)push(i+w)}if(qt<n*.12){self.postMessage({id,skip:1});return}const edge=new Uint8Array(n);for(let i=0;i<n;i++){if(bg[i])continue;const X=i%w;if((X>0&&bg[i-1])||(X<w-1&&bg[i+1])||(i>=w&&bg[i-w])||(i<n-w&&bg[i+w]))edge[i]=1}for(let i=0;i<n;i++){const k=i*4;if(bg[i]){const l=(d[k]+d[k+1]+d[k+2])/3;d[k]=d[k+1]=d[k+2]=0;d[k+3]=Math.max(0,Math.min(255,(255-l)*3))}else if(edge[i]){const mn=Math.min(d[k],d[k+1],d[k+2]);if(mn>150){const f=(mn-150)/105;d[k+3]=Math.round(255*(1-f*.85));}}}x.putImageData(im,0,0);self.postMessage({id,blob:await c.convertToBlob({type:'image/webp',quality:.9})})}catch(err){self.postMessage({id,skip:1})}}`;
      let worker = null; const jobs = new Map(); const done = new Map(); let seq = 0;
      const applyTo = (img, blobUrl) => { if (!blobUrl) return; img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.src = blobUrl; const b = img.closest('.product-block'); if (b) b.classList.add('sxp-keyed'); };
      const run = img => {
        const url = img.currentSrc || img.src; if (!url || img.dataset.sxKeyed) return;
        img.dataset.sxKeyed = '1';
        const u = new URL(url, location.href); if (u.origin !== location.origin && !/cdn\.shopify\.com$/.test(u.hostname)) return;
        u.searchParams.set('width', '640');
        const key = u.href;
        if (done.has(key)) { applyTo(img, done.get(key)); return; }
        if (!worker) { try { worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' }))); } catch (e) { return; } worker.onmessage = e => { const j = jobs.get(e.data.id); jobs.delete(e.data.id); if (!j) return; const b = e.data.blob ? URL.createObjectURL(e.data.blob) : ''; done.set(j.key, b); j.imgs.forEach(im => applyTo(im, b)); }; }
        for (const j of jobs.values()) if (j.key === key) { j.imgs.push(img); return; }
        const id = ++seq; jobs.set(id, { key, imgs: [img] }); worker.postMessage({ id, url: key });
      };
      const kio = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; const t = e.target; kio.unobserve(t); if (t.currentSrc && t.complete) run(t); else t.addEventListener('load', () => run(t), { once: true }); }), { rootMargin: '300px 0px' });
      const watch = () => document.querySelectorAll(CARD_IMG).forEach(i => { if (!i.dataset.sxKeyWatch) { i.dataset.sxKeyWatch = '1'; kio.observe(i); } });
      watch();
      const content = document.getElementById('content');
      if (content) { let mt = 0; new MutationObserver(() => { clearTimeout(mt); mt = setTimeout(watch, 200); }).observe(content, { childList: true, subtree: true }); }
    }
    /* Reviews: the average becomes a chrome score beside the diamonds */
    const score = () => {
      const w = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg[data-average-rating]');
      const inner = w && w.querySelector('.jdgm-rev-widg__summary-inner');
      if (!inner) return false;
      if (!inner.querySelector('.sxp-score')) {
        const p = document.createElement('p'); p.className = 'sxp-score'; p.setAttribute('aria-hidden', 'true');
        const b = document.createElement('b'); b.textContent = (parseFloat(w.dataset.averageRating) || 0).toFixed(2);
        const i = document.createElement('i'); i.textContent = '/5';
        p.append(b, i); inner.prepend(p);
      }
      return true;
    };
    if (!score()) { let n = 0; const t = setInterval(() => { if (score() || ++n > 40) clearInterval(t); }, 500); }
    /* Reviews: the strongest testimonies first (rating, then photos, then substance) */
    const rank = r => { const sc = +((r.querySelector('.jdgm-rev__rating') || {}).dataset || {}).score || 0; const pics = r.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__vid').length; const len = ((r.querySelector('.jdgm-rev__body') || {}).textContent || '').trim().length; return sc * 1000 + Math.min(pics, 3) * 120 + Math.min(len, 400) / 4; };
    const bestFirst = () => {
      const w = document.querySelector('#judgeme_product_reviews');
      const sel = w && w.querySelector('select.jdgm-sort-dropdown');
      const list = w && w.querySelector('.jdgm-rev-widg__reviews');
      if (!sel || !list) return false;
      if (!w.dataset.sxSorted) {
        w.dataset.sxSorted = '1';
        /* reorder in place only: asking Judge.me to re-sort makes it scroll the page down to the widget */
        const order = () => { const revs = [...list.querySelectorAll(':scope > .jdgm-rev')]; const sorted = revs.slice().sort((x, y) => rank(y) - rank(x)); if (sorted.some((r, i) => r !== revs[i])) sorted.forEach(r => list.appendChild(r)); };
        order(); new MutationObserver(() => { clearTimeout(list._sxo); list._sxo = setTimeout(order, 60); }).observe(list, { childList: true });
      }
      return true;
    };
    if (!bestFirst()) { let n = 0; const t = setInterval(() => { if (bestFirst() || ++n > 40) clearInterval(t); }, 500); }
    const toast = hud.querySelector('[data-sx-toast]');
    const glitch = hud.querySelector('[data-sx-glitch]');
    const pulse = (n, c = 'is-on') => { if (!n) return; n.classList.remove(c); void n.offsetWidth; n.classList.add(c); };
    const flavorName = () => { const i = document.querySelector('#content.nf-rp .product-detail .option-selector input:checked'); return i ? i.value : ''; };
    let world = null;
    loot = () => {
      const t = toast && toast.querySelector('[data-sx-toast-t]');
      if (t) { const f = el.dataset.sxPal === 'flavor' ? flavorName() : ''; t.textContent = (el.dataset.sxName || '') + (f ? ' · ' + f : ''); }
      pulse(toast); pulse(glitch);
      if (world) world.flash = 0.3;
    };
    hookCart();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = matchMedia('(max-width: 749px)').matches;
    const canvas = el.querySelector('canvas');
    try { world = canvas ? new World(canvas) : null; } catch (e) { world = null; }
    if (world && hud !== el) { const fc = document.createElement('canvas'); fc.className = 'sx-fx'; fc.setAttribute('aria-hidden', 'true'); hud.prepend(fc); world.attachVeil(fc); }
    if (world) { world.door = 0.6; el.classList.add('is-coded'); if (matchMedia('(max-width: 749px)').matches) world.target = 1 / 30; }
    if (!world) { el.classList.add('is-still'); return; }
    let flavors = {};
    try { flavors = JSON.parse(el.dataset.sxFlavors || '{}'); } catch (e) {}
    const palette = nm => {
      const pal = el.dataset.sxPal;
      if (pal !== 'flavor') return pal;
      const n = nm || flavorName();
      const acc = hex(toneOf(n) || flavors[n.toLowerCase()] || '#e00018');
      const p = clone(PAL.blood);
      p.accent = acc; p.acc = 1.15;
      p.ember = p.ember.map((c, i) => mix(c, acc[i], 0.45));
      p.fog = p.fog.map((c, i) => mix(c, acc[i] * 0.3, 0.3));
      return p;
    };
    world.palette(palette());
    if (reduced) { world.size(innerWidth, innerHeight); world.cur = world.tgt; world.dirty = true; world.draw(); el.classList.add('is-live'); return; }
    /* further down the page the hall changes its light: the story (fire), the testimonies (bone), the rest of the arsenal (blood) */
    const ZONES = [['#content.nf-rp .nf-edition', 'fire'], ['#judgeme_product_reviews', 'bone'], ['#content.nf-rp .product-recommendations', 'blood']];
    let zone = 0, zoneT = 0;
    const seenZ = new Set([0]);
    document.addEventListener('change', e => {
      if (e.target && e.target.closest && e.target.closest('.option-selector') && el.dataset.sxPal === 'flavor') {
        const r = (e.target.closest('label') || e.target.closest('.option-selector')).getBoundingClientRect();
        if (!zone) world.palette(palette(), { x: r.left + r.width / 2, y: r.top + r.height / 2 }, FX_PDP_TAP);
      }
    });
    if (PREVIEW && el.dataset.sxPal === 'flavor') {
      previewChip();
      let pj = null;
      const product = () => pj || (pj = fetch('/products/' + handle + '.js').then(r => r.json()).catch(() => null));
      /* the gallery turns to the flavour's own tub, through the theme's own thumbnail */
      const showArt = async name => {
        const p = await product(); if (!p) return;
        const v = p.variants.find(x => x.options.includes(name) && x.featured_image); if (!v) return;
        const f = v.featured_image.src.split('?')[0].split('/').pop().replace(/\.\w+$/, '');
        const t = [...document.querySelectorAll('#content.nf-rp .product-detail .gallery .thumbnail')].find(a => { const im = a.querySelector('img'); return im && (im.getAttribute('src') || '').includes(f); });
        if (t) t.click();
      };
      document.addEventListener('click', e => {
        const lab = e.target.closest && e.target.closest('#content.nf-rp .product-detail .option-selector--swatch .opt-label');
        if (!lab) return;
        const inp = document.getElementById(lab.htmlFor); if (!inp) return;
        const r = lab.getBoundingClientRect(), from = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
        document.querySelectorAll('.sxp-preview').forEach(x => x.classList.remove('sxp-preview'));
        if (inp.disabled || inp.classList.contains('is-unavailable')) { e.preventDefault(); lab.classList.add('sxp-preview'); if (!zone) world.palette(palette(inp.value), from, FX_PDP_TAP); showArt(inp.value); }
        else if (inp.checked) { if (!zone) world.palette(palette(), from, FX_PDP_TAP); showArt(inp.value); }
      }, true);
    }
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    const look = [0, 0], lookT = [0, 0];
    addEventListener('pointermove', e => { if (fine.matches) { lookT[0] = (e.clientX / innerWidth - 0.5) * 1.1; lookT[1] = -(e.clientY / innerHeight - 0.5) * 0.7; } }, { passive: true });
    const depth = hud.querySelector('[data-sx-depth]');
    let resizeT = 0;
    /* on a wide screen the aisle and its doorway line up behind the product, so the relic stands in the nave */
    const size = () => {
      setTop(); world.size(innerWidth, innerHeight);
      const g = innerWidth >= 990 && !document.documentElement.classList.contains('sxp-viewing') && document.querySelector('#content.nf-rp .product-detail .gallery');
      if (g) { const r = g.getBoundingClientRect(); world.shift = -((r.left + r.width / 2) - innerWidth / 2) / (innerHeight / 2); } else world.shift = 0;
      world.lz = -1;
    };
    addEventListener('resize', () => { clearTimeout(resizeT); resizeT = setTimeout(size, 120); }, { passive: true });
    document.addEventListener('sxp:view', size);
    size();
    let raf = 0, last = 0, skip = 0, z = 2.6, actT = 0;
    /* phones (incl. 120 Hz screens): time-based rate, 30 fps while scrolling or animating, 15 fps when the hall is idle */
    const poke = () => { actT = performance.now(); };
    addEventListener('scroll', poke, { passive: true }); addEventListener('touchstart', poke, { passive: true });
    const tick = now => {
      raf = document.hidden ? 0 : requestAnimationFrame(tick);
      if (!raf) return;
      if (mobile || world.half) { const busy = now - actT < 900 || world.wave || world.pt >= 0 || world.flash > 0.03; if (last && now - last < (busy ? 31 : 64)) return; }
      const dt = last ? Math.min(0.08, (now - last) / 1000) : 1 / 60; last = now;
      const zT = 2.6 + scrollY / innerHeight * 2.4;
      z += (zT - z) * (1 - Math.exp(-dt * 6));
      if (!fine.matches) { if (world.lite) { lookT[0] = 0; lookT[1] = 0; } else { const t = now / 1000; lookT[0] = Math.sin(t * 0.17) * 0.3; lookT[1] = Math.cos(t * 0.13) * 0.1; } }
      look[0] += (lookT[0] - look[0]) * (1 - Math.exp(-dt * 2.2)); look[1] += (lookT[1] - look[1]) * (1 - Math.exp(-dt * 2.2));
      world.z = z; world.look = look; world.time += dt; world.vel = 0; world.flash *= Math.exp(-dt * 3.5);
      if ((zoneT -= dt) <= 0) {
        zoneT = 0.2; let zi = 0;
        ZONES.forEach(([sel], i) => { const n = document.querySelector(sel); if (n && n.getBoundingClientRect().top < innerHeight * 0.55) zi = i + 1; });
        if (zi !== zone) { zone = zi; world.door = zi ? 0.3 : 0.6; world.palette(zi ? ZONES[zi - 1][1] : palette(), null, seenZ.has(zi) ? FX_QUIET : FX_PDP_FIRST); seenZ.add(zi); }
      }
      world.step(dt); world.draw();
      if (depth) sett(depth, (z * 10).toFixed(1).padStart(5, '0'));
      const deep = scrollY > 260; if (deep !== hud._deep) { hud._deep = deep; hud.classList.toggle('is-deep', deep); }
    };
    document.addEventListener('visibilitychange', () => { if (!document.hidden && !raf) { last = 0; raf = requestAnimationFrame(tick); } });
    raf = requestAnimationFrame(tick);
    requestAnimationFrame(() => el.classList.add('is-live'));
  });

  window.NFSanctum = { World, Relic, project, PAL, init, initPdp, TIER, WORLDS };
  /* the buy bar can be put away: a small tab on its edge hides it, the same tab brings it back (remembered for the visit) */
  const dockToggle = () => {
    if (document.querySelector('.sx-dock-tog')) return;
    const lee = document.querySelector('.sx .sx-sticky');
    if (!lee && !document.documentElement.classList.contains('sx-pdp-on')) return;
    const bar = () => lee || document.getElementById('corner-sticky-atc-outer-container');
    /* the Lee bar also steps aside on the legend, armory and finale chapters (CSS): the tab follows it there too */
    const leeRoot = lee && lee.closest('.sx');
    const shown = b => lee ? b.classList.contains('is-visible') && !/^[347]$/.test(leeRoot ? leeRoot.dataset.sxAt || '' : '') : /(^|\s)translate-y-0(\s|$)/.test(b.className);
    let off = false;
    try { off = sessionStorage.getItem('sxdock') === '0'; } catch (e) {}
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sx-dock-tog';
    btn.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 4.2l4 3.6 4-3.6" fill="none" stroke="currentColor" stroke-width="1.8"/></svg><span></span>';
    document.body.appendChild(btn);
    const label = btn.querySelector('span');
    let last = null;
    const paint = () => {
      document.documentElement.classList.toggle('sx-dock-off', off);
      btn.classList.toggle('is-off', off);
      label.textContent = off ? 'Buy' : 'Hide';
      btn.setAttribute('aria-label', off ? 'Show the buy bar' : 'Hide the buy bar');
      btn.setAttribute('aria-expanded', String(!off));
    };
    const place = () => {
      const b = bar(), vis = !!b && shown(b);
      /* re-seat once the bar's own slide ends, so the tab never rests on a bar still moving */
      if (b && !b._sxTe) { b._sxTe = 1; b.addEventListener('transitionend', e => { if (e.target === b) place(); }); }
      if (vis !== btn._vis) { btn._vis = vis; btn.classList.toggle('is-on', vis); }
      if (!vis) return;
      /* Shopify's own preview strip (store staff only) sits under everything at the bottom: keep the tab above it */
      const pb = document.getElementById('PBarNextFrameWrapper'), pr = pb && pb.getBoundingClientRect(), pbh = pr && pr.height && pr.top < innerHeight ? Math.round(innerHeight - pr.top) : 0;
      setv(btn, '--sx-dock-pb', pbh + 'px');
      if (!off) { const r = b.getBoundingClientRect(); if (r.height) last = { right: Math.max(8, Math.round(innerWidth - r.right + 10)), bottom: Math.max(0, Math.round(innerHeight - r.top)) }; }
      if (last) { setv(btn, 'right', last.right + 'px'); setv(btn, '--sx-dock-b', last.bottom + 'px'); }
    };
    btn.addEventListener('click', () => { off = !off; try { sessionStorage.setItem('sxdock', off ? '0' : '1'); } catch (e) {} paint(); place(); });
    paint(); place();
    setInterval(() => { if (!document.hidden) place(); }, 300);
    addEventListener('resize', place, { passive: true });
  };
  const boot = () => { init(); initPdp(); dockToggle(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
